import { createSlice } from '@reduxjs/toolkit';
import {
  ADMIN,
  AR,
  DB,
  TRANSACTION,
  REPORT,
  UTILITY,
  DOCTORWORKBENCH,
  GENERALLEDGER,
  Group,
  HMS,
  INV,
  LAB,
  MIS,
  MRD,
  NURSE,
  OT,
  RADIOLOGY,
  STATIONARY,
  APPOINTMENT,
  PATIENTREGISTRATION,
  HEALTHCHECKUP,
  OUTPATIENT,
  INPATIENT,
  NURSESTATION,
  BLOODBANK,
  DOCTORREVIEW,
  MISREPORT,
  OPERATIONTHEATRE,
  PHARMACY,
  SOFTWAREMANAGEMENT,
  SYSTEMCONTROL,
  TALLY,
  OPDCLINICALMANAGEMENT,
  STOREMANAGEMENT,
  DOCTORACCOUNTING,
  ASSETMANAGEMENT,
  CSSD,
  EQUIMENTMAINTENACE,
  DOCTORMANAGEMENT,
  PHYSIOTHERAPHY,
  DISCHARGESUMMARY,
  HR,
  AMBULANCE,
  CANTEEN,
  HOUSEKEEPING,
  LABOURROOM,
  EYES,
  DENTIST,
  PACS,
  TPA
} from '../../assets';

const organizationSlice = createSlice({
  name: 'organization',
  initialState: [
    {
      id: 'group',
      label: 'Group',
      img: Group,
      to: '/group',
      options: [
        {
          id: 'inv',
          label: 'inv',
          img: INV,
          to: '/inv'
        },
        {
          id: 'ar',
          label: 'ar',
          img: AR,
          to: '/ar'
        },
        {
          id: 'generalLedger',
          label: 'Ledger',
          img: GENERALLEDGER,
          to: '/general-ledger'
        },
        {
          id: 'stationary',
          label: 'stationary',
          img: STATIONARY,
          to: '/stationary'
        },
        {
          id: 'mis',
          label: 'mis',
          img: MIS,
          to: '/mis'
        },
        {
          id: 'admin',
          label: 'admin',
          img: ADMIN,
          to: '/admin'
        }
      ]
    },
    {
      id: 'hospital',
      label: 'Hospital',
      img: HMS,
      to: '/hospital',
      options: [
        {
          id: 'appointment-booking',
          label: 'Appointment',
          img: APPOINTMENT,
          to: '/appointment-booking',
          menu: [
            {
              id: 'transaction',
              label: 'Transaction',
              img: TRANSACTION,
              children: [
                {
                  id: 'appointment-booking',
                  label: 'Appointment Booking',
                  to: '/hospital/appointment-booking/appointment-booking'
                },
                {
                  id: 'appointment-status',
                  label: 'Appointment Status',
                  to: '/hospital/appointment-booking/appointment-status'
                }
              ]
            }
          ]
        },
        {
          id: 'patient-admission',
          label: 'Patient Registeration',
          img: PATIENTREGISTRATION,
          to: '/patient-admission',
          menu: [
            {
              id: 'transaction',
              label: 'Transaction',
              img: TRANSACTION,
              children: [
                {
                  id: 'opd',
                  label: 'OPD',
                  children: [
                    {
                      id: 'patient-admission',
                      label: 'Patient Registeration',
                      to: '/hospital/patient-admission'
                    }
                  ]
                }
              ]
            },
            {
              id: 'reports',
              label: 'Reports',
              img: REPORT,
              children: [
                {
                  id: 'collection-summary',
                  label: 'Collection Summary',
                  to: '/hospital/patient-admission/collection-summary'
                }
              ]
            }
          ]
        },
        {
          id: 'outpatient-management',
          label: 'OutPatient Management(OPD)',
          img: OUTPATIENT,
          to: '/outpatient-management',
          menu: [
            {
              id: 'master',
              label: 'Master',
              img: DB,
              children: [
                {
                  id: 'services',
                  label: 'Services',
                  children: [
                    {
                      id: 'service-master',
                      label: 'Service Master',
                      to: '/hospital/outpatient-management/service-master'
                    }
                  ]
                },
                {
                  id: 'staff-master',
                  label: 'Staff Master',
                  children: [
                    {
                      id: 'doctor-unit-master',
                      label: 'Doctor Unit Master',
                      to: '/hospital/outpatient-management/doctor-unit-master'
                    },
                    {
                      id: 'doctor-master',
                      label: 'Doctor Master',
                      to: '/hospital/outpatient-management/doctor-master'
                    },
                    {
                      id: 'referral-master',
                      label: 'Referral Master',
                      to: '/hospital/outpatient-management/referral-master'
                    }
                  ]
                },
                {
                  id: 'other-master',
                  label: 'Other Master',
                  children: [
                    {
                      id: 'opd-type',
                      label: 'OPD Type',
                      to: '/hospital/outpatient-management/opd-type'
                    },
                    {
                      id: 'admission-type',
                      label: 'Admission Type',
                      to: '/hospital/outpatient-management/admission-type'
                    },
                    {
                      id: 'relation-master',
                      label: 'Relation Master',
                      to: '/hospital/outpatient-management/relation-master'
                    },
                    {
                      id: 'department-master',
                      label: 'Department Master',
                      to: '/hospital/outpatient-management/department-master'
                    },
                    {
                      id: 'location-master',
                      label: 'Location Master',
                      to: '/hospital/outpatient-management/location-master'
                    },
                    {
                      id: 'state-master',
                      label: 'State Master',
                      to: '/hospital/outpatient-management/state-master'
                    },
                    {
                      id: 'city-master',
                      label: 'City Master',
                      to: '/hospital/outpatient-management/city-master'
                    },
                    {
                      id: 'speciality-master',
                      label: 'Speciality Master',
                      to: '/hospital/outpatient-management/speciality-master'
                    },
                    {
                      id: 'feegroup-master',
                      label: 'FeeGroup Master',
                      to: '/hospital/outpatient-management/feegroup-master'
                    },
                    {
                      id: 'vertical-master',
                      label: 'Vertical Master',
                      to: '/hospital/outpatient-management/vertical-master'
                    },
                    {
                      id: 'group-master',
                      label: 'Group Master',
                      to: '/hospital/outpatient-management/group-master'
                    },
                    {
                      id: 'subgroup-master',
                      label: 'SubGroup Master',
                      to: '/hospital/outpatient-management/subgroup-master'
                    },
                    {
                      id: 'rank-master',
                      label: 'Rank Master',
                      to: '/hospital/outpatient-management/rank-master'
                    },
                    {
                      id: 'reason-master',
                      label: 'Reason Master',
                      to: '/hospital/outpatient-management/reason-master'
                    },
                    {
                      id: 'flutype-master',
                      label: 'Flu Type Master',
                      to: '/hospital/outpatient-management/flutype-master'
                    }
                  ]
                },

                {
                  id: 'sponsor-master',
                  label: 'Sponsor Master',
                  to: '/hospital/outpatient-management/sponsor-master'
                },
                {
                  id: 'control-unit-master',
                  label: 'Control Unit Master',
                  to: '/hospital/outpatient-management/control-unit-master'
                },
                {
                  id: 'discount-master',
                  label: 'Discount Master',
                  to: '/hospital/outpatient-management/discount-master'
                },
                {
                  id: 'discharge-summary-template-master',
                  label: 'Discharge Summary Template Master',
                  to: '/hospital/outpatient-management/discharge-summary-template-master'
                },
                {
                  id: 'user-wise-doctor-mapping',
                  label: 'User Wise Doctor Mapping',
                  to: '/hospital/outpatient-management/user-wise-doctor-mapping'
                },
                {
                  id: 'authority-master',
                  label: 'Authority Master',
                  to: '/hospital/outpatient-management/authority-master'
                },
              ]
            },
            {
              id: 'transaction',
              label: 'Transaction',
              img: TRANSACTION,
              children: [
                {
                  id: 'scheme-management',
                  label: 'Scheme Management',
                  children: [
                    {
                      id: 'scheme-allotment',
                      label: 'Scheme Allotment',
                      to: '/hospital/outpatient-management/scheme-allotment'
                    }
                  ]
                },
                {
                  id: 'opd',
                  label: 'OPD',
                  children: [
                    {
                      id: 'patient-registeration',
                      label: 'Patient Registeration',
                      to: '/hospital/outpatient-management/patient-registeration'
                    },
                    {
                      id: 'opd-billing',
                      label: 'OPD Billing',
                      to: '/hospital/outpatient-management/opd-billing'
                    },
                    {
                      id: 'opd-vitals',
                      label: 'OPD Vitals',
                      to: '/hospital/outpatient-management/opd-vitals'
                    },
                    {
                      id: 'partial-cancellation',
                      label: 'Partial Cancellation',
                      to: '/hospital/outpatient-management/partial-cancellation'
                    },

                  ]
                },
                {
                  id: 'queue-details',
                  label: 'Queue Management Details',
                  to: '/hospital/outpatient-management/queue-details'
                },
              ]
            },
            {
              id: 'reports',
              label: 'Reports',
              img: REPORT,
              children: [
                {
                  id: 'registration-register',
                  label: 'Registration Register',
                  to: '/hospital/outpatient-management/registration-register'
                },
                {
                  id: 'collection-summary',
                  label: 'Collection Summary',
                  to: '/hospital/outpatient-management/collection-summary'
                },
                {
                  id: 'appointment-register-report',
                  label: 'Appointment Register Report',
                  to: '/hospital/outpatient-management/appointment-register-report'
                },
                {
                  id: 'doctor-master-report',
                  label: 'Doctor Master Report',
                  to: '/hospital/outpatient-management/doctor-master-report'
                },
                {
                  id: 'service-master-report',
                  label: 'Service Master Report',
                  to: '/hospital/outpatient-management/service-master-report'
                },
                {
                  id: 'service-package-report',
                  label: 'Service Package Report',
                  to: '/hospital/outpatient-management/service-package-report'
                },
                {
                  id: 'doctor-ledger-report',
                  label: 'Doctor Ledger Report',
                  to: '/hospital/outpatient-management/doctor-ledger-report'
                },
                {
                  id: 'opd-reports',
                  label: 'OPD Reports',
                  children: [
                    {
                      id: 'consultant-wise-opd',
                      label: 'Consultant Wise OPD',
                      to: '/hospital/outpatient-management/consultant-wise-opd'
                    },
                    {
                      id: 'department-wise-opd',
                      label: 'Department Wise OPD',
                      to: '/hospital/outpatient-management/department-wise-opd'
                    },
                    {
                      id: 'sponsor-wise-opd',
                      label: 'Sponsor Wise OPD',
                      to: '/hospital/outpatient-management/sponsor-wise-opd'
                    },
                    {
                      id: 'opd-referral-report',
                      label: 'OPD Referral Report',
                      to: '/hospital/outpatient-management/opd-referral-report'
                    },
                    {
                      id: 'opd-patient-ledger',
                      label: 'OPD Patient Ledger',
                      to: '/hospital/outpatient-management/opd-patient-ledger'
                    },
                    {
                      id: 'doctor-wise-opd-procedure-reports',
                      label: 'Doctor Wise Opd And Procedures Reports',
                      to: '/hospital/outpatient-management/doctor-wise-opd-procedure-reports'
                    },
                    {
                      id: 'opd-vital-report',
                      label: 'Opd Vitals Report ',
                      to: '/hospital/outpatient-management/opd-vital-report'
                    },
                  ]
                }
              ]
            }
          ]
        },
        {
          id: 'laboratory',
          label: 'Laboratory',
          img: LAB,
          to: '/laboratory',
          menu: [
            {
              id: 'master',
              label: 'Master',
              img: DB,
              children: [
                {
                  id: 'test-main-group-master',
                  label: ' Group Master',
                  to: '/hospital/laboratory/test-main-group-master'
                },
                {
                  id: 'test-sub-group-master',
                  label: ' Sub Group Master',
                  to: '/hospital/laboratory/test-sub-group-master'
                },
                {
                  id: 'category-master',
                  label: 'Category Master',
                  to: '/hospital/laboratory/category-master'
                },
                {
                  id: 'specimen-master',
                  label: 'Specimen Master',
                  to: '/hospital/laboratory/specimen-master'
                },
                {
                  id: 'unit-master',
                  label: 'Unit Master',
                  to: '/hospital/laboratory/unit-master'
                },
                {
                  id: 'tube-type-master',
                  label: 'Tube-Type Master',
                  to: '/hospital/laboratory/tube-type-master'
                },
                {
                  id: 'test-master',
                  label: 'Test Master',
                  to: '/hospital/laboratory/test-master'
                },
                {
                  id: 'test-panel-master',
                  label: 'Test Panel Master',
                  to: '/hospital/laboratory/test-panel-master'
                },
                {
                  id: 'lis-discount-master',
                  label: 'Discount Master',
                  to: '/hospital/laboratory/lis-discount-master'
                },
                {
                  id: 'discount-authority-master',
                  label: 'Discount Authority Master',
                  to: '/hospital/laboratory/lis-discount-authority-master'
                },
                {
                  id: 'sponsor-master',
                  label: 'Sponsor Master',
                  to: '/hospital/laboratory/lis-sponsor-master'
                },
                {
                  id: 'templates-master',
                  label: 'Templates Master',
                  to: '/hospital/laboratory/lis-templates-master'
                },
                {
                  id: 'lis-price-list-master',
                  label: 'Price List Master',
                  to: '/hospital/laboratory/lis-price-list-master'
                },
                {
                  id: 'referral-master',
                  label: 'Referral Master',
                  to: '/hospital/laboratory/lis-referral-master'
                },
                {
                  id: 'lab-authority-doctor-master',
                  label: 'Lab Authority Doctor Master',
                  to: '/hospital/laboratory/lab-authority-doctor-master'
                },
                {
                  id: 'user-authority-master',
                  label: 'User Authority Master',
                  to: '/hospital/laboratory/user-authority-master'
                }
              ]
            },
            {
              id: 'transaction',
              label: 'Transaction',
              img: TRANSACTION,
              children: [
                {
                  id: 'investigation-booking',
                  label: 'Investigation Booking',
                  to: '/hospital/laboratory/investigation-booking'
                },
                {
                  id: 'sample-collection',
                  label: 'Sample Collection',
                  to: '/hospital/laboratory/sample-collection'
                },
                {
                  id: 'sample-received',
                  label: 'Sample Received',
                  to: '/hospital/laboratory/sample-received'
                },
                {
                  id: 'result-dashboard',
                  label: 'Result dashboard',
                  to: '/hospital/laboratory/result-dashboard'
                },
                // {
                //   id: 'allow-lab-test-cancellation',
                //   label: 'Allow Lab Test Cancellation',
                //   to: '/hospital/laboratory/allow-lab-test-cancellation'
                // },
                // {
                //   id: 'lab-test-date-change',
                //   label: 'Lab Test Dtae Change',
                //   to: '/hospital/laboratory/lab-test-date-change'
                // },
                // {
                //   id: 'investigation-report-print',
                //   label: 'Investigation Report Print',
                //   to: '/hospital/laboratory/investigation-report-print'
                // },


              ]
            },
            {
              id: 'report',
              label: 'Report',
              img: REPORT,
              children: [
                {
                  id: 'daily-investigation-report',
                  label: 'Daily Investigation Report ',
                  to: '/hospital/laboratory/daily-investigation-report'
                },
                {
                  id: 'sample-collection-report',
                  label: 'Sample Collection Report ',
                  to: '/hospital/laboratory/sample-collection-report'
                },
                {
                  id: 'Uhid-IPD-No-Wise-report',
                  label: 'Uhid/IPD No Wise report',
                  to: '/hospital/laboratory/Uhid-IPD-No-Wise-report'
                }
              ]
            }
          ]
        },
        {
          id: 'radiology',
          label: 'Radiology',
          img: RADIOLOGY,
          to: '/radiology',
          menu: [
            {
              id: 'master',
              label: 'Master',
              img: DB,
              children: [
                {
                  id: 'template-master',
                  label: 'Template Master',
                  to: '/hospital/radiology/template-master'
                },
                {
                  id: 'room-master',
                  label: 'Room Master',
                  to: '/hospital/radiology/room-master'
                },
                {
                  id: 'radiology-authority-doctor-master',
                  label: ' Authorised Doctor ',
                  to: '/hospital/radiology/radiology-authority-doctor-master'
                },
                {
                  id: 'diagnosis-master',
                  label: 'Diagnosis Master',
                  to: '/hospital/radiology/diagnosis-master'
                }
              ]
            },
            {
              id: 'transaction',
              label: 'Transaction',
              img: TRANSACTION,
              children: [
                {
                  id: 'radiology-service-booking',
                  label: 'Radiology Service Booking',
                  to: '/hospital/radiology/radiology-service-booking'
                },
                {
                  id: 'radiology-service-acknowledgement',
                  label: 'Radiology Service Acknowledgement',
                  to: '/hospital/radiology/radiology-service-acknowledgement'
                },
                {
                  id: 'rad-service-ack-update-status',
                  label: 'Rad. Service Ack. Update Status',
                  to: '/hospital/radiology/rad-service-ack-update-status'
                },
                {
                  id: 'procedure-report',
                  label: 'Procedure Report',
                  to: '/hospital/radiology/procedure-report'
                }
              ]
            },
            {
              id: 'report',
              label: 'Report',
              img: REPORT,
              children: [
                {
                  id: 'radiology-service-booking-report',
                  label: 'Radiology Service Booking Report',
                  to: '/hospital/radiology/radiology-service-booking-report'
                },
                {
                  id: 'radiology-status-report',
                  label: 'Radiology Status Report ',
                  to: '/hospital/radiology/radiology-status-report'
                }
              ]
            },
            {
              id: 'utility',
              label: 'Utility',
              img: UTILITY,
              children: [
                {
                  id: 'procedure-report-authority',
                  label: 'Procedure Report Authority',
                  to: '/hospital/radiology/procedure-report-authority'
                },
                {
                  id: 'subgroup-user-mapping',
                  label: 'Sub Group User Mapping',
                  to: '/hospital/radiology/sub-group-user-mapping'
                }
              ]
            }
          ]
        },
         {
          id: 'physiotherapy',
          label: 'Physiotherapy',
          img: PHYSIOTHERAPHY,
          to: '/physiotherapy',
          menu: [
            {
              id: 'master',
              label: 'Master',
              img: DB,
              children: [
                {
                  id: 'physiotherapy-service-master',
                  label: 'Service Master',
                  to: '/hospital/physiotherapy/physiotherapy-service-master'
                }
              ]
            },
            {
              id: 'transaction',
              label: 'Transaction',
              img: TRANSACTION,
              children: [
                {
                  id: 'physiotherapy-booking',
                  label: 'Physiotherapy Booking',
                  to: '/hospital/physiotherapy/physiotherapy-booking'
                }
              ]
            },
            {
              id: 'reports',
              label: 'Report',
              img: REPORT,
              children: [
                {
                  id: 'physiotherapy-booking-report',
                  label: 'Booking Report',
                  to: '/hospital/physiotherapy/physiotherapy-booking-report'
                }
              ]
            }
          ]
        },
        {
          id: 'inpatient-management',
          label: 'Inpatient Management(IPD)',
          to: '/inpatient-management',
          img: INPATIENT,
          menu: [
            {
              id: 'master',
              label: 'Master',
              img: DB,
              children: [
                {
                  id: 'services',
                  label: 'Services',
                  children: [
                    {
                      id: 'service-master',
                      label: 'Service Master',
                      to: '/hospital/inpatient-management/service-master'
                    }
                  ]
                },
                {
                  id: 'price-list',
                  label: 'Price List',
                  children: [
                    {
                      id: 'price-list-master',
                      label: 'Price List Master',
                      to: '/hospital/inpatient-management/price-list-master'
                    },
                    {
                      id: 'doctor-fees-setup',
                      label: 'Doctor Fees Setup',
                      to: '/hospital/inpatient-management/doctor-fees-setup'
                    }
                  ]
                },
                {
                  id: 'room-master',
                  label: 'Room Masters',
                  children: [
                    {
                      id: 'room-master',
                      label: 'Room Master',
                      to: '/hospital/inpatient-management/room-master'
                    },
                    {
                      id: 'ward-category-master',
                      label: 'Ward Category Master',
                      to: '/hospital/inpatient-management/ward-category-master'
                    },
                    {
                      id: 'ward-master',
                      label: 'Ward Master',
                      to: '/hospital/inpatient-management/ward-master'
                    },
                    {
                      id: 'floor-master',
                      label: 'Floor Master',
                      to: '/hospital/inpatient-management/floor-master'
                    },
                    {
                      id: 'department-unit-master',
                      label: 'Department Unit Master',
                      to: '/hospital/inpatient-management/department-unit-master'
                    },
                    {
                      id: 'department-unit-head',
                      label: 'Department Unit Head',
                      to: '/hospital/inpatient-management/department-unit-head'
                    },
                    {
                      id: 'nursing-station-master',
                      label: 'Nursing Station Master',
                      to: '/hospital/inpatient-management/nursing-station-master'
                    }
                  ]
                },
                {
                  id: 'discharge-summary-template-master',
                  label: 'Discharge Summary Template Master',
                  to: '/hospital/inpatient-management/discharge-summary-template-master'
                },
                {
                  id: 'discharge-summary-templates',
                  label: 'Discharge Summary Templates',
                  to: '/hospital/inpatient-management/discharge-summary-templates'
                },
                {
                  id: 'visit-type-master',
                  label: 'Visit Type Master',
                  to: '/hospital/inpatient-management/visit-type-master'
                },

              ]
            },
            {
              id: 'transaction',
              label: 'Transaction',
              img: TRANSACTION,
              children: [
                {
                  id: 'ipd',
                  label: 'IPD',
                  children: [
                    {
                      id: 'indoor-registeration',
                      label: 'IPD Registeration',
                      to: '/hospital/inpatient-management/indoor-registeration'
                    },
                    {
                      id: 'indoor-status',
                      label: 'IPD Status',
                      to: '/hospital/inpatient-management/indoor-status'
                    },

                    {
                      id: 'indoor-service',
                      label: 'IPD Billing',
                      to: '/hospital/inpatient-management/indoor-service'
                    },
                    {
                      id: 'consultant-transfer',
                      label: 'Consultant Transfer',
                      to: '/hospital/inpatient-management/consultant-transfer'
                    },
                    {
                      id: 'indoor-billing-management',
                      label: 'Final Bill',
                      to: '/hospital/inpatient-management/indoor-billing-management'
                    },

                    {
                      id: 'patient-discharge',
                      label: 'Patient Discharge',
                      to: '/hospital/inpatient-management/patient-discharge'
                    },
                    {
                      id: 'discharge-summary',
                      label: ' Discharge Summary',
                      to: '/hospital/inpatient-management/discharge-summary'
                    },
                    {
                      id: 'change-ipd-sponsor',
                      label: 'Change Ipd Sponsor',
                      to: '/hospital/inpatient-management/change-ipd-sponsor'
                    },
                    {
                      id: 'clean-room',
                      label: 'Clean Room',
                      to: '/hospital/inpatient-management/clean-room'
                    }
                  ]
                },
                {
                  id: 'payment-refund-voucher',
                  label: 'Payment Refund Voucher',
                  to: '/hospital/inpatient-management/payment-refund-voucher'
                },
                {
                  id: 'receipt-voucher',
                  label: 'Receipt Voucher',
                  to: '/hospital/inpatient-management/receipt-voucher'
                },
                {
                  id: 'reception-enquiry',
                  label: 'Reception Enquiry',
                  to: '/hospital/inpatient-management/reception-enquiry'
                },
                {
                  id: 'gate-pass',
                  label: 'Gate Pass',
                  to: '/hospital/inpatient-management/gate-pass'
                },
                {
                  id: 'consultant-visiting',
                  label: 'Consultant Visiting',
                  to: '/hospital/inpatient-management/consultant-visiting'
                },

              ]
            },
            {
              id: 'utility',
              label: 'Utility',
              img: TRANSACTION,
              children: [
                {
                  id: 'ward-wise-consultant-visit-charges',
                  label: 'Ward Wise Consultant Visit Charges',
                  to: '/hospital/inpatient-management/ward-wise-consultant-visit-charges'
                },

              ]
            },
            {
              id: 'reports',
              label: 'Reports',
              img: REPORT,
              children: [
                {
                  id: 'ipd-reports',
                  label: 'IPD Reports',
                  children: [
                    {
                      id: 'active-patient-reports',
                      label: 'Active Patient Report',
                      to: '/hospital/inpatient-management/active-patient-reports'
                    },
                    {
                      id: 'ipd-admission-register-reports',
                      label: 'IPD Admission Register Report',
                      to: '/hospital/inpatient-management/ipd-admission-register-reports'
                    },
                    {
                      id: 'indoor-collection-register',
                      label: 'Indoor Collection Register',
                      to: '/hospital/inpatient-management/indoor-collection-register'
                    },
                    {
                      id: 'ipd-discharge-register',
                      label: 'IPD Discharge Register',
                      to: '/hospital/inpatient-management/ipd-discharge-register'
                    },
                    {
                      id: 'sponsor-wise-ipd-report',
                      label: 'Sponsor Wise IPD Report',
                      to: '/hospital/inpatient-management/sponsor-wise-ipd-report'
                    },
                    {
                      id: 'doctor-ledger',
                      label: 'Doctor Ledger',
                      to: '/hospital/inpatient-management/doctor-ledger'
                    }
                  ]
                },
                {
                  id: 'collection-summary',
                  label: "Collection Summary Report",
                  to: "/hospital/inpatient-management/collection-summary"
                },
                {
                  id: 'consultant-revenue-analysis-report',
                  label: 'Consultant Revenue Analysis Report',
                  to: '/hospital/inpatient-management/consultant-revenue-analysis-report'
                },
                {
                  id: 'service-register-report',
                  label: 'Service Register Report',
                  to: '/hospital/inpatient-management/service-register-report'
                },
                {
                  id: 'refund-register',
                  label: 'Refund Register',
                  to: '/hospital/inpatient-management/refund-register'
                },
                {
                  id: 'credit-register-report',
                  label: 'Credit Register report',
                  to: '/hospital/inpatient-management/credit-register-report'
                },
                {
                  id: 'balance-register-report',
                  label: 'Balance Register report',
                  to: '/hospital/inpatient-management/balance-register-report'
                },
                {
                  id: 'bill-register-report',
                  label: 'Bill Register report',
                  to: '/hospital/inpatient-management/bill-register-report'
                },
                {
                  id: 'discount-register-report',
                  label: 'Discount Register report',
                  to: '/hospital/inpatient-management/discount-register-report'
                },
                {
                  id: 'collection-analysis-report',
                  label: 'Collection Analysis Report',
                  to: '/hospital/inpatient-management/collection-analysis-report'
                },

              ]
            }
          ]
        },
        {
          id: 'nurse-module',
          label: 'Nurse Station',
          to: '/nurse-module',
          img: NURSESTATION,
          menu: [
            {
              id: 'master',
              label: 'Master',
              img: DB,
              children: [
                {
                  id: 'discharge-mode-master',
                  label: 'Discharge Mode Master',
                  to: '/hospital/nurse-module/discharge-mode-master'
                }
              ]
            },
            {
              id: 'transaction',
              label: 'Transaction',
              img: TRANSACTION,
              children: [
                {
                  id: 'room-chart',
                  label: 'Room Chart',
                  to: '/hospital/nurse-module/room-chart'
                },
                // {
                //   id: 'room-allotment',
                //   label: 'Room Allotment ',
                //   to: '/hospital/nurse-module/room-allotment'
                // },
                {
                  id: 'room-transfer',
                  label: 'Room Transfer',
                  to: '/hospital/nurse-module/room-transfer'
                },
                // {
                //   id: 'room-transfer-accept',
                //   label: 'Room Transfer Accept ',
                //   to: '/hospital/nurse-module/room-transfer-accept'
                // },
                {
                  id: 'indent-requisition-form',
                  label: 'Indent Requisition Form ',
                  to: '/hospital/nurse-module/indent-requisition-form'
                },
                {
                  id: 'patient-discharge-request',
                  label: 'Patient Discharge Request',
                  to: '/hospital/nurse-module/patient-discharge-request'
                },
                {
                  id: 'blood-request',
                  label: 'Blood Request',
                  to: '/hospital/nurse-module/blood-request'
                }
                // {
                //   id: 'relieve-discharged-patient',
                //   label: 'Relieve Discharged Patient ',
                //   to: '/hospital/nurse-module/relieve-discharged-patient '
                // },
                // {
                //   id: 'room-cleaning-status',
                //   label: 'Room Cleaning Status',
                //   to: '/hospital/nurse-module/room-cleaning-status'
                // },
                // {
                //   id: 'investigation-print',
                //   label: 'Investigation Print',
                //   to: '/hospital/nurse-module/investigation-print'
                // },
                // {
                //   id: 'view-test-result',
                //   label: 'View Test Result ',
                //   to: '/hospital/nurse-module/view-test-result'
                // },
                // {
                //   id: 'nursing-handover-form',
                //   label: 'Nursing Handover Form ',
                //   to: '/hospital/nurse-module/nursing-handover-form'
                // }
              ]
            },
            {
              id: 'report',
              label: 'Report',
              img: REPORT,
              children: [
                {
                  id: 'room-status-report',
                  label: 'Room Status Report',
                  to: '/hospital/nurse-module/room-status-report'
                }
              ]
            }
          ]
        },
        {
          id: 'operation-theatre',
          label: 'Operation Theatre',
          to: '/ot',
          img: OPERATIONTHEATRE,
          menu: [
            {
              id: 'master',
              label: 'Master',
              img: DB,
              children: [
                {
                  id: 'anaesthesia-master',
                  label: 'Anaesthesia  Master',
                  to: '/hospital/ot/anaesthesia-master'
                },
                {
                  id: 'equipment-type-master',
                  label: 'Equipment Type Master',
                  to: '/hospital/ot/equipment-type-master'
                },
                {
                  id: 'equipment-master',
                  label: 'Equipment  Master',
                  to: '/hospital/ot/equipment-master'
                },
                {
                  id: 'operation-theatre-master',
                  label: 'Operation Theatre Master',
                  to: '/hospital/ot/operation-theatre-master'
                },
                {
                  id: 'region-master',
                  label: 'Region Master',
                  to: '/hospital/ot/region-master'
                },
                {
                  id: 'ot-notes',
                  label: 'OT Notes',
                  to: '/hospital/ot/ot-notes'
                }
              ]
            },
            {
              id: 'transaction',
              label: 'Transaction',
              img: TRANSACTION,
              children: [
                {
                  id: 'ot-schedule-status',
                  label: 'OT Schedule Calender',
                  to: '/hospital/ot/ot-schedule-status'
                },
                {
                  id: 'ot-schedule',
                  label: 'OT Schedule',
                  to: '/hospital/ot/ot-schedule'
                },
                {
                  id: 'ot-schedule-cancel',
                  label: 'OT schedule Cancel',
                  to: '/hospital/ot/ot-schedule-cancel'
                },
                {
                  id: 'patient-transfer',
                  label: 'Patient Transfer',
                  to: '/hospital/ot/patient-transfer'
                },
                {
                  id: 'ot-entry',
                  label: 'OT Entry',
                  to: '/hospital/ot/ot-entry'
                },
                // {
                //   id: 'patient-transfer',
                //   label: 'Patient Transfer',
                //   to: '/hospital/ot/patient-transfer'
                // },
              ]
            },
            {
              id: 'report',
              label: 'Reports',
              img: REPORT,
              children: [
                {
                  id: 'ot-schedule-register',
                  label: 'OT Schedule Register',
                  to: '/hospital/ot/ot-schedule-register'
                },
                {
                  id: 'ot-entry-register',
                  label: 'OT Entry register',
                  to: '/hospital/ot/ot-entry-register'
                }
              ]
            }
          ]
        },
        {
          id: 'blood-bank',
          label: 'Blood Bank',
          to: '/blood-bank',
          img: BLOODBANK,
          menu: [
            {
              id: 'master',
              label: 'Master',
              img: DB,
              children: [
                {
                  id: 'component-master',
                  label: 'Component Master',
                  to: '/hospital/blood-bank/component-master'
                },
                {
                  id: 'unit-master',
                  label: 'Unit Master',
                  to: '/hospital/blood-bank/unit-master'
                },
                {
                  id: 'group-master',
                  label: 'Group Master',
                  to: '/hospital/blood-bank/group-master'
                },
                {
                  id: 'bloodbank-master',
                  label: 'Blood Bank Master',
                  to: '/hospital/blood-bank/bloodbank-master'
                },
                {
                  id: 'bloodtype-master',
                  label: 'Blood Type Master',
                  to: '/hospital/blood-bank/bloodtype-master'
                }
              ]
            },
            {
              id: 'transaction',
              label: 'Transaction',
              img: DB,
              children: [
                {
                  id: 'donar-master',
                  label: 'Donor Master',
                  to: '/hospital/blood-bank/donar-master'
                },
                // {
                //   id: 'blood-request-status',
                //   label: 'Blood Request Status',
                //   to: '/hospital/blood-bank/blood-request-status'
                // },
                {
                  id: 'issue-blood',
                  label: 'Issue Blood ',
                  to: '/hospital/blood-bank/issue-blood'
                },
                {
                  id: 'intake-blood',
                  label: 'Intake Blood',
                  to: '/hospital/blood-bank/intake-blood'
                }
              ]
            },
            {
              id: 'Reports',
              label: 'Reports',
              img: DB,
              children: [
                {
                  id: 'blood-request-status-report',
                  label: 'Blood Request Status Report',
                  to: '/hospital/blood-bank/blood-request-status-report'
                },
                {
                  id: 'donor-master-report',
                  label: 'Donor Master Report',
                  to: '/hospital/blood-bank/donor-master-report'
                },
                {
                  id: 'intake-blood-report',
                  label: 'Intake Blood Report',
                  to: '/hospital/blood-bank/intake-blood-report'
                },

              ]
            },

          ]
        },
        {
          id: 'labour-room',
          label: 'Gynecology & IVF',
          img: LABOURROOM,
          to: '/labour-room',
          menu: [
            {
              id: 'transaction',
              label: 'Transaction',
              img: DB,
              children: [
                // {
                //   id: 'labour-room',
                //   label: 'Labour Room',
                //   to: '/hospital/labour-room/labour-room'
                // },
                {
                  id: 'ivf_examination',
                  label: 'IVF Examination',
                  to: '/hospital/labour-room/ivf-examination'
                },
                {
                  id: 'ivf_treatement',
                  label: 'IVF Treatement',
                  to: '/hospital/labour-room/ivf-treatement'
                }
              ]
            }
          ]
        },
        {
          id: 'mis-report',
          label: 'Mis Report',
          img: MISREPORT,
          to: '/mis-report',
          menu: [
            {
              id: 'reports',
              label: 'Reports',
              img: DB,
              children: [
                {
                  id: 'collection-summary',
                  label: 'Collection Summary Report',
                  to: '/hospital/mis-report/collection-summary'
                },
                {
                  id: 'consultant-revenue-analysis-report',
                  label: 'Consultant Revenue Analysis Report',
                  to: '/hospital/mis-report/consultant-revenue-analysis-report'
                },
                {
                  id: 'service-register-report',
                  label: 'Service Register Report',
                  to: '/hospital/mis-report/service-register-report'
                },
                {
                  id: 'refund-register',
                  label: 'Refund Register Report',
                  to: '/hospital/mis-report/refund-register'
                },
                {
                  id: 'credit-register-report',
                  label: 'Credit Register Report',
                  to: '/hospital/mis-report/credit-register-report'
                },
                {
                  id: 'balance-register-report',
                  label: 'Balance Register Report',
                  to: '/hospital/mis-report/balance-register-report'
                },
                {
                  id: 'discount-register-report',
                  label: 'Discount Register Report',
                  to: '/hospital/mis-report/discount-register-report'
                },
                {
                  id: 'collection-analysis-report',
                  label: 'Collection Analysis Report',
                  to: '/hospital/mis-report/collection-analysis-report'
                },
                {
                  id: 'doctor-ledger',
                  label: 'IPD Doctor Ledger Report',
                  to: '/hospital/mis-report/doctor-ledger'
                },
                {
                  id: 'indoor-collection-register',
                  label: 'IPD Collection Register Report',
                  to: '/hospital/mis-report/indoor-collection-register'
                },

              ]
            },

          ]
        },
        // {
        //   id: 'inventory',
        //   label: 'Pharmacy',
        //   img: PHARMACY,
        //   to: '/inventory',
        //   menu: [
        //     {
        //       id: 'master',
        //       label: 'Master',
        //       img: DB,
        //       children: [
        //         {
        //           id: 'product-management',
        //           label: 'Product Management',
        //           children: [
        //             {
        //               id: 'uqc-master',
        //               label: 'UQC Master',
        //               to: '/hospital/inventory/uqc-master'
        //             },
        //             {
        //               id: 'product-master',
        //               label: 'Product Master',
        //               to: '/hospital/inventory/product-master'
        //             },
        //             // {
        //             //   id: 'product-details',
        //             //   label: 'Product Details ',
        //             //   to: '/hospital/inventory/product-details'
        //             // }
        //             // {
        //             //   id: 'import-product-master',
        //             //   label: 'Import Product Master',
        //             //   to: '/hospital/inventory/import-product-master'
        //             // },
        //             // {
        //             //   id: 'request-new-product',
        //             //   label: 'Request For New Product',
        //             //   to: '/hospital/inventory/request-new-product'
        //             // },
        //             // {
        //             //   id: 'package-medicine-detail',
        //             //   label: 'Package Medicine Detail',
        //             //   to: '/hospital/inventory/package-medicine-detail'
        //             // }
        //           ]
        //         },
        //         {
        //           id: 'storage-management',
        //           label: 'Storage Management',
        //           children: [
        //             {
        //               id: 'ware-house',
        //               label: 'Ware House',
        //               to: '/hospital/inventory/ware-house'
        //             },
        //             {
        //               id: 'user-wise-warehouse-mapping',
        //               label: 'User wise Warehouse Mapping',
        //               to: '/hospital/inventory/user-wise-warehouse-mapping'
        //             }
        //           ]
        //         },
        //         // {
        //         //   id: 'tax-charge-discount',
        //         //   label: 'Tax Charge Discount',
        //         //   to: '/hospital/inventory/tax-charge-discount'
        //         // },
        //         {
        //           id: 'purchase-order-terms',
        //           label: 'Purchase Order Terms ',
        //           to: '/hospital/inventory/purchase-order-term'
        //         }
        //       ]
        //     },
        //     {
        //       id: 'transaction',
        //       label: 'Purchase Transaction',
        //       img: TRANSACTION,
        //       children: [
        //         {
        //           id: 'procurement',
        //           label: 'Procurement',
        //           children: [
        //             // {
        //             //   id: 'requisition',
        //             //   label: 'Requisition',
        //             //   to: '/hospital/inventory/requisition'
        //             // },
        //             // {
        //             //   id: 'auto-generate-purchase-request',
        //             //   label: 'Auto Generate Purchase Request',
        //             //   to: '/hospital/inventory/auto-generate-purchase-request'
        //             // },
        //             // {
        //             //   id: 'requisition-camcellation',
        //             //   label: 'Requisition Cancellation',
        //             //   to: '/hospital/inventory/requisition-cancellation'
        //             // },
        //             // {
        //             //   id: 'request-quotation-from-supplier',
        //             //   label: 'Request Qoutation From Supplier',
        //             //   to: '/hospital/inventory/request-quotation-from-supplier'
        //             // },
        //             // {
        //             //   id: 'purchase-qoutation',
        //             //   label: 'Purchase Qoutation',
        //             //   to: '/hospital/inventory/purchase-qoutation'
        //             // },
        //             {
        //               id: 'purchase-requisition',
        //               label: 'Purchase Requisition',
        //               to: '/hospital/inventory/purchase-requisition'
        //             },
        //             {
        //               id: 'purchase-order',
        //               label: 'Purchase Order',
        //               to: '/hospital/inventory/purchase-order'
        //             },
        //             // {
        //             //   id: 'cancel-purchase-order',
        //             //   label: 'cancel Purchase Order',
        //             //   to: '/hospital/inventory/cancel-purchase-order'
        //             // }
        //           ]
        //         },
        //         {
        //           id: 'consigment-receipt',
        //           label: 'Consigment Reciept',
        //           to: '/hospital/inventory/consigment-receipt'
        //         },
        //         {
        //           id: 'consignment-return',
        //           label: 'Consigment Return',
        //           to: '/hospital/inventory/consignment-return'
        //         },
        //         {
        //           id: 'good-reciept-note',
        //           label: 'Good Reciept Note[GRN]',
        //           to: '/hospital/inventory/good-reciept-note'
        //         },
        //         {
        //           id: 'purchase-return',
        //           label: 'Purchase Return',
        //           to: '/hospital/inventory/purchase-return'
        //         },
        //         {
        //           id: 'purchase-authorize',
        //           label: 'Purchase Authorize',
        //           to: '/hospital/inventory/purchase-authorize'
        //         },
        //         {
        //           id: 'product-details',
        //           label: 'Product Details',
        //           to: '/hospital/inventory/product-details'
        //         },
        //         {
        //           id: 'warehouse-stock-transfer-request',
        //           label: 'Warehouse Stock Transfer Request',
        //           to: '/hospital/inventory/warehouse-stock-transfer-request'
        //         },
        //         {
        //           id: 'warehouse-stock-transfer-request-authorise',
        //           label: 'Warehouse Stock Transfer Request Authorise',
        //           to: '/hospital/inventory/warehouse-stock-transfer-request-authorise'
        //         },
        //         {
        //           id: 'stock-transfer-voucher',
        //           label: 'Stock Transfer Voucher',
        //           to: '/hospital/inventory/stock-transfer-voucher'
        //         },
        //         {
        //           id: 'stock-transfer-acceptance',
        //           label: 'Stock Transfer Acceptance',
        //           to: '/hospital/inventory/stock-transfer-acceptance'
        //         },
        //         {
        //           id: 'stock-adjustment',
        //           label: 'Stock Adjustment',
        //           to: '/hospital/inventory/stock-adjustment'
        //         }
        //       ]
        //     },
        //     {
        //       id: 'sale-transaction',
        //       label: 'Sale Transaction',
        //       img: TRANSACTION,
        //       children: [
        //         // {
        //         //   id: 'sale-return',
        //         //   label: 'Sale Return',
        //         //   to: '/hospital/inventory/sale-return'
        //         // },
        //         {
        //           id: 'retail-sale-pos',
        //           label: 'Retail Sale POS',
        //           to: '/hospital/inventory/retail-sale-pos'
        //         },
        //         {
        //           id: 'retail-sale-return',
        //           label: 'Retail Sale Return',
        //           to: '/hospital/inventory/retail-sale-return'
        //         },
        //         {
        //           id: 'indent-medicine-issue',
        //           label: 'Indoor Medicine Issue',
        //           to: '/hospital/inventory/indent-medicine-issue'
        //         },
        //         {
        //           id: 'indoor-medicine-return',
        //           label: 'Indoor Medicine Return',
        //           to: '/hospital/inventory/indoor-medicine-return'
        //         },
        //         {
        //           id: 'patient-receipt-voucher',
        //           label: 'Patient Receipt Voucher',
        //           to: '/hospital/inventory/patient-receipt-voucher'
        //         },
        //         {
        //           id: 'department-wise-consumption',
        //           label: 'Department Wise Consumption',
        //           to: '/hospital/inventory/department-wise-consumption'
        //         },
        //         {
        //           id: 'patient-wise-consumption',
        //           label: 'Patient Wise Consumption',
        //           to: '/hospital/inventory/patient-wise-consumption'
        //         },
        //         {
        //           id: 'cancel-ipd-indent',
        //           label: 'Cancel IPD Indent',
        //           to: '/hospital/inventory/cancel-ipd-indent'
        //         },

        //       ]
        //     },
        //     {
        //       id: 'report',
        //       label: 'Report',
        //       img: REPORT,
        //       children: [
        //         {
        //           id: 'master-report',
        //           label: 'Master Report',
        //           children: [
        //             {
        //               id: 'product-master-report',
        //               label: 'Product Master Report',
        //               to: '/hospital/inventory/product-master-report'
        //             },
        //             {
        //               id: 'product-master-report-excel',
        //               label: 'Product Master Report Excel',
        //               to: '/hospital/inventory/product-master-report-excel'
        //             }
        //           ]
        //         },
        //         {
        //           id: 'purchase-reports',
        //           label: 'Purchase Reports',
        //           children: [
        //          {
        //           id: 'purchase-requisition-report',
        //           label: 'Purchase Requisition Report',
        //           to: '/hospital/inventory/purchase-requisition-report'
        //            },
        //           {
        //           id: 'purchase-order-report',
        //           label: 'Purchase Order Report',
        //           to: '/hospital/inventory/purchase-order-report'
        //         },
        //         {
        //           id: 'purchase-summary',
        //           label: 'Purchase Summary',
        //           to: '/hospital/inventory/purchase-summary'
        //         },
        //         {
        //           id: 'grn-report',
        //           label: 'GRN Reports',
        //           to: '/hospital/inventory/grn-report'
        //         },
        //           {
        //           id: 'purchase-return-report',
        //           label: 'Purchase Return Report',
        //           to: '/hospital/inventory/purchase-return-report'
        //         },
        //         {
        //           id: 'gst-report',
        //           label: 'GST Report',
        //           to: '/hospital/inventory/gst-report'
        //         },
        //            {
        //           id: 'product-ledger',
        //           label: 'Product Legder',
        //           to: '/hospital/inventory/product-ledger'
        //         },
        //             {
        //           id: 'product-tracking-report',
        //           label: 'Product tracking Report',
        //           to: '/hospital/inventory/product-tracking-report'
        //         },
        //           ]
        //         },

        //          {
        //           id: 'sale-reports',
        //           label: 'Sale Reports',
        //           children: [
        //            {
        //           id: 'collection-summary',
        //           label: 'Collection Summary',
        //           to: '/hospital/inventory/collection-summary'
        //         },
        //         {
        //           id: 'item-wise-sale-reort-register',
        //           label: 'Item Wise Sale Report Register',
        //           to: '/hospital/inventory/item-wise-sale-reort-register'
        //         },
        //         {
        //           id: 'credit-report',
        //           label: 'Credit Register Report',
        //           to: '/hospital/inventory/credit-report'
        //         },

        //           ]
        //         },
        //         {
        //           id: 'stock-transfer-report',
        //           label: 'Stock Transfer Report',
        //           children: [
        //             {
        //               id: 'stock-transfer-request-report',
        //               label: 'Stock Transfer Request Report',
        //               to: '/hospital/inventory/stock-transfer-request-report'
        //             },
        //             {
        //               id: 'stock-transfer-report',
        //               label: 'Stock Transfer  Report',
        //               to: '/hospital/inventory/stock-transfer-report'
        //             },
        //             {
        //               id: 'stock-transfer-accept-report',
        //               label: 'Stock Transfer Accept Report',
        //               to: '/hospital/inventory/stock-transfer-accept-report'
        //             }
        //           ]
        //         },
        //         {
        //           id: 'stock-reports',
        //           label: 'Stock Reports',
        //           children: [
        //             {
        //               id: 'stock-transfer-form',
        //               label: 'Stock Transfer Form',
        //               to: '/hospital/inventory/stock-transfer-form'
        //             },
        //             {
        //               id: 'stock-status',
        //               label: 'Stock Status',
        //               to: '/hospital/inventory/stock-status'
        //             },
        //             {
        //               id: 'stock-transfer-report',
        //               label: 'Stock Transfer Report',
        //               to: '/hospital/inventory/stock-transfer-report'
        //             },
        //             {
        //               id: 'stock-adjutment-report',
        //               label: 'Stock Adjument Report',
        //               to: '/hospital/inventory/stock-adjutment-report'
        //             },
        //             {
        //               id: 'warehouse-report',
        //               label: 'Warehouse Report',
        //               to: '/hospital/inventory/warehouse-report'
        //             },
        //             {
        //               id: 'zero-stock-report',
        //               label: 'Zero Stock Product Report',
        //               to: '/hospital/inventory/zero-stock-report'
        //             },
        //             {
        //               id: 'product-info',
        //               label: 'Product Info',
        //               to: '/hospital/inventory/product-info'
        //             },
        //           ]
        //         },
        //         {
        //           id: 'batch-wise-reports',
        //           label: 'Batch Wise Reports',
        //           children: [
        //             {
        //               id: 'batch-wise-item-transaction',
        //               label: 'Batch Wise Item Transaction',
        //               to: '/hospital/inventory/batch-wise-item-transaction'
        //             },
        //             {
        //               id: 'batch-wise-expired-item',
        //               label: 'Batch Wise Expired Item',
        //               to: '/hospital/inventory/batch-wise-expired-item'
        //             },
        //             {
        //               id: 'batch-wise-near-expiring-item',
        //               label: 'Batch Wise Near Expired Item',
        //               to: '/hospital/inventory/batch-wise-near-expiring-item'
        //             }
        //           ]
        //         }
        //       ]
        //     },
        //     // {
        //     //   id: 'Utility',
        //     //   label: 'Utility',
        //     //   img: DB,
        //     //   children: [
        //     //     {
        //     //       id: 'update-batch-rate',
        //     //       label: 'Update Batch & Rate',
        //     //       to: '/hospital/inventory/update-batch-rate'
        //     //     },
        //     //   ]
        //     // }
        //   ]
        // },

        {
          id: 'pharmacy',
          label: 'Pharmacy',
          img: PHARMACY,
          to: '/pharmacy',
          menu: [
            // ================= Master =================
            {
              id: 'master',
              label: 'Master',
              img: DB,
              children: [
                {
                  id: 'medicines',
                  label: 'Medicines',
                  to: '/hospital/pharmacy/medicines',

                },
                {
                  id: 'inventory',
                  label: 'Inventory',
                  to: '/hospital/pharmacy/inventory',

                },
                {
                  id: 'racks',
                  label: 'Racks',
                  to: '/hospital/pharmacy/racks',

                },
                {
                  id: 'suppliers',
                  label: 'Suppliers',
                  to: '/hospital/pharmacy/suppliers',

                },
              ],
            },

            // ================= Purchase Transaction =================
            {
              id: 'transaction',
              label: 'Purchase Transaction',
              img: TRANSACTION,
              children: [
                {
                  id: 'purchase',
                  label: 'Purchase',
                  to: '/hospital/pharmacy/purchases',

                },
              ],
            },

            // ================= Sale Transaction =================
            {
              id: 'sale-transaction',
              label: 'Sale Transaction',
              img: TRANSACTION,
              children: [
                {
                  id: 'sales',
                  label: 'Sales',
                  to: '/hospital/pharmacy/sales',

                },
                {
                  id: 'returns',
                  label: 'Returns',
                  to: '/hospital/pharmacy/returns',

                },
                // {
                //   id: 'patients',
                //   label: 'Patients',
                //   to: '/hospital/pharmacy/patients',

                // },
                // {
                //   id: 'prescriptions',
                //   label: 'Prescriptions',
                //   to: '/hospital/pharmacy/prescriptions',

                // },
              ],
            },

            // ================= Report =================
            {
              id: 'report',
              label: 'Report',
              img: REPORT,
              children: [
                {
                  id: 'reports',
                  label: 'Reports',
                  to: '/hospital/pharmacy/reports',
                },
              ],
            },
          ],
        },

        {
          id: 'hospital-inventory',
          label: 'Hospital Inventory',
          img: INV,
          to: '/hospital-inventory',
          menu: [
            // ================= Master =================
            {
              id: 'master',
              label: 'Master',
              img: DB,
              children: [
                {
                  id: 'items',
                  label: 'Items',
                  to: '/hospital/hospital-inventory/items',

                },
                {
                  id: 'inventory',
                  label: 'Inventory',
                  to: '/hospital/hospital-inventory/inventory',

                },
                {
                  id: 'racks',
                  label: 'Racks',
                  to: '/hospital/hospital-inventory/racks',

                },
                {
                  id: 'department-stock',
                  label: 'Department Stock',
                  to: '/hospital/hospital-inventory/department-stock',

                },
                {
                  id: 'suppliers',
                  label: 'Suppliers',
                  to: '/hospital/hospital-inventory/suppliers',

                },
              ],
            },

            // ================= Purchase Transaction =================
            {
              id: 'transaction',
              label: 'Purchase Transaction',
              img: TRANSACTION,
              children: [
                {
                  id: 'purchase',
                  label: 'Purchase',
                  to: '/hospital/hospital-inventory/purchases',

                },
              ],
            },

            // ================= Sale Transaction =================
            {
              id: 'sale-transaction',
              label: 'Sale Transaction',
              img: TRANSACTION,
              children: [
                {
                  id: 'item-issues',
                  label: 'Item Issues',
                  to: '/hospital/hospital-inventory/item-issues',

                },
                {
                  id: 'returns',
                  label: 'Returns',
                  to: '/hospital/hospital-inventory/item-issue-returns',

                },
              ],
            },

            // ================= Report =================
            {
              id: 'report',
              label: 'Report',
              img: REPORT,
              children: [
                {
                  id: 'reports',
                  label: 'Reports',
                  to: '/hospital/hospital-inventory/reports',
                },
              ],
            },
          ],
        },

        {
          id: 'software-management',
          label: 'Software Management',
          img: SOFTWAREMANAGEMENT,
          to: '/software-management',
          menu: [
            {
              id: 'setup',
              label: 'Set Up',
              img: DB,
              children: [
                {
                  id: 'voucher-series-setup',
                  label: 'Voucher Series Setup',
                  to: '/hospital/software-management/voucher-series-setup'
                },
                {
                  id: 'stock-management',
                  label: 'Stock Management',
                  to: '/hospital/software-management/stock-management'
                }
                // {
                //   id: 'system-parameter',
                //   label: 'System Parameter',
                //   to: '/hospital/software-management/system-parameter'
                // },
                // {
                //   id: 'system-parameter-hms',
                //   label: 'System Parameter HMS',
                //   to: '/hospital/software-management/system-parameter-hms'
                // },
                // {
                //   id: 'system-parameter-lis',
                //   label: 'System Parameter LIS',
                //   to: '/hospital/software-management/system-parameter-lis'
                // },
                // {
                //   id: 'ware-house-mapping',
                //   label: 'Ware House Mapping',
                //   to: '/hospital/software-management/ware-house-mapping'
                // },
                // {
                //   id: 'multi-level-authorization',
                //   label: 'Multi Level Authorization',
                //   to: '/hospital/software-management/multi-level-authorization'
                // },
                // {
                //   id: 'user-rights-report',
                //   label: 'User Rights Report',
                //   to: '/hospital/software-management/user-right-report'
                // },
                // {
                //   id: 'voucher-series-setup',
                //   label: 'Voucher Series Setup',
                //   to: '/hospital/software-management/voucher-series-setup'
                // },
                // {
                //   id: 'mobile-device-user-setup',
                //   label: 'Mobile Device User Setup',
                //   to: '/hospital/software-management/mobile-device-user-setup'
                // },
                // {
                //   id: 'invoice-configuration',
                //   label: 'Invoice Configuration',
                //   to: '/hospital/software-management/invoice-configuration'
                // },
                // {
                //   id: 'reports-name-parameter',
                //   label: 'Reports Name Parameter',
                //   to: '/hospital/software-management/reports-name-parameter'
                // },
                // {
                //   id: 'pending-order-update',
                //   label: 'Pending Order Update',
                //   to: '/hospital/software-management/pending-order-update'
                // },
                // {
                //   id: 'sales-location',
                //   label: 'Sales Location',
                //   to: '/hospital/software-management/sales-location'
                // },
                // {
                //   id: 'multi-level-authorization-hms',
                //   label: 'Multi Level Authorization HMS',
                //   to: '/hospital/software-management/multi-level-authorization-hms'
                // },
                // {
                //   id: 'remote-customer-mapping',
                //   label: 'Remote Customer Mapping',
                //   to: '/hospital/software-management/remote-customer-mapping'
                // },
                // {
                //   id: 'shift-master',
                //   label: 'Shift Master',
                //   to: '/hospital/software-management/shift-master'
                // },
                // {
                //   id: 'user-wise-shift-mapping',
                //   label: 'User Wise Shift Mapping',
                //   to: '/hospital/software-management/user-wise-shift-mapping'
                // },
                // {
                //   id: 'city-master',
                //   label: 'City Master',
                //   to: '/hospital/software-management/city-master'
                // },
                // {
                //   id: 'user-wise-product-type-mapping',
                //   label: 'User Wise Product Type Mapping',
                //   to: '/hospital/software-management/user-wise-prdouct-type-mapping'
                // }
              ]
            },
            {
              id: 'Role & Permissions',
              label: 'Role & Permissions',
              img: DB,
              children: [
                {
                  id: 'printoption',
                  label: 'Print Option',
                  to: '/hospital/software-management/printoption'
                },
                {
                  id: 'role',
                  label: 'Roles',
                  to: '/hospital/software-management/role'
                },
                {
                  id: 'role-permissions',
                  label: 'Role Permissions',
                  to: '/hospital/software-management/role-permissions'
                },
                {
                  id: 'user-management',
                  label: 'User Management',
                  to: '/hospital/software-management/user-management'
                },
                {
                  id: 'sponsor-alocator',
                  label: 'Sponsor Alocator',
                  to: '/hospital/software-management/sponsor-alocator'
                }
              ]
            },
            {
              id: 'import-data',
              label: 'Import Data',
              img: DB,
              children: [
                {
                  id: 'pervice-import-data',
                  label: 'Service Master Import Data',
                  to: '/hospital/software-management/service-import-data'
                },
                {
                  id: 'doctor-import-data',
                  label: 'Doctor Import Data',
                  to: '/hospital/software-management/doctor-import-data'
                },
                {
                  id: 'sponser-import-data',
                  label: 'Sponser Import Data',
                  to: '/hospital/software-management/sponser-import-data'
                },
                {
                  id: 'patient-import-data',
                  label: 'Patient Import Data',
                  to: '/hospital/software-management/patient-import-data'
                },
                {
                  id: 'product-master-import-data',
                  label: 'Product Master Import Data',
                  to: '/hospital/software-management/product-master-import-data'
                },
                {
                  id: 'Pharmacy-Stock-import-data',
                  label: 'Pharmacy Stock Import Data',
                  to: '/hospital/software-management/Pharmacy-Stock-import-data'
                },
                {
                  id: 'test-item-master-import-data',
                  label: 'Test Item Master Import Data',
                  to: '/hospital/software-management/test-item-master-import-data'
                },
                {
                  id: 'test-master-import-data',
                  label: 'Test Master Import Data',
                  to: '/hospital/software-management/test-master-import-data'
                },
                {
                  id: 'opd-billing-import-data',
                  label: 'Opd Billing Import Data',
                  to: '/hospital/software-management/opd-billing-import-data'
                },
                {
                  id: 'ipd-billing-import-data',
                  label: 'Ipd Billing Import Data',
                  to: '/hospital/software-management/ipd-billing-import-data'
                },
                {
                  id: 'price-list-master-import-data',
                  label: 'Pricr List MasterImport Data',
                  to: '/hospital/software-management/price-list-master-import-data'
                },
                {
                  id: 'lab-price-list-master-import-data',
                  label: 'Lab Price List Master Import Data',
                  to: '/hospital/software-management/lab-price-list-master-import-data'
                },
                {
                  id: 'general-product-master-import',
                  label: 'General Product Master Import',
                  to: '/hospital/software-management/general-product-master-import'
                },
                {
                  id: 'general-product-stock-master-import',
                  label: 'General Product Stock Master Import',
                  to: '/hospital/software-management/general-product-stock-master-import'
                },
                {
                  id: 'state-city-master-import',
                  label: 'State City Master Import',
                  to: '/hospital/software-management/state-city-master-import'
                }
              ]
            }
          ]
        },
        {
          id: 'eye-clinic',
          label: 'Eye Clinic',
          img: EYES,
          to: '/eye-clinic',
          menu: [
            {
              id: 'setup',
              label: 'Set Up',
              img: DB,
              children: [
                {
                  id: 'system-parameter',
                  label: 'System Parameter',
                  to: '/hospital/eye-clinic/system-parameter'
                }
              ]
            }
          ]
        },
        // {
        //   id: 'store-management',
        //   label: 'Store Management',
        //   img: STOREMANAGEMENT,
        //   to: '/store-management',
        //   menu: [
        //     {
        //       id: 'master',
        //       label: 'Master',
        //       img: DB,
        //       children: [
        //         {
        //           id: 'product-management',
        //           label: 'Product Management',
        //           children: [
        //             {
        //               id: 'uqc-master',
        //               label: 'UQC Master',
        //               to: '/hospital/store-management/uqc-master'
        //             },
        //             {
        //               id: 'product-master',
        //               label: 'Product Master',
        //               to: '/hospital/store-management/product-master'
        //             },
        //             {
        //               id: 'product-details',
        //               label: 'Product Details ',
        //               to: '/hospital/store-management/product-details'
        //             }
        //           ]
        //         },
        //         {
        //           id: 'storage-management',
        //           label: 'Storage Management',
        //           children: [
        //             {
        //               id: 'ware-house',
        //               label: 'Ware House',
        //               to: '/hospital/store-management/ware-house'
        //             }
        //           ]
        //         }
        //       ]
        //     },
        //     {
        //       id: 'transaction',
        //       label: 'Purchase Transaction',
        //       img: DB,
        //       children: [
        //         {
        //           id: 'procurement',
        //           label: 'Procurement',
        //           children: [
        //             // {
        //             //   id: 'requisition',
        //             //   label: 'Requisition',
        //             //   to: '/hospital/inventory/requisition'
        //             // },
        //             // {
        //             //   id: 'auto-generate-purchase-request',
        //             //   label: 'Auto Generate Purchase Request',
        //             //   to: '/hospital/inventory/auto-generate-purchase-request'
        //             // },
        //             // {
        //             //   id: 'requisition-camcellation',
        //             //   label: 'Requisition Cancellation',
        //             //   to: '/hospital/inventory/requisition-cancellation'
        //             // },
        //             // {
        //             //   id: 'request-quotation-from-supplier',
        //             //   label: 'Request Qoutation From Supplier',
        //             //   to: '/hospital/inventory/request-quotation-from-supplier'
        //             // },
        //             {
        //               id: 'purchase-qoutation',
        //               label: 'Purchase Qoutation',
        //               to: '/hospital/inventory/purchase-qoutation'
        //             },
        //             {
        //               id: 'purchase-order',
        //               label: 'Purchase Order',
        //               to: '/hospital/store-management/purchase-order'
        //             },
        //             // {
        //             //   id: 'cancel-purchase-order',
        //             //   label: 'cancel Purchase Order',
        //             //   to: '/hospital/inventory/cancel-purchase-order'
        //             // }
        //           ]
        //         },
        //         {
        //           id: 'consigment-receipt',
        //           label: 'Consigment Reciept',
        //           to: '/hospital/store-management/consigment-receipt'
        //         },
        //         {
        //           id: 'consignment-return',
        //           label: 'Consigment Return',
        //           to: '/hospital/store-management/consignment-return'
        //         },
        //         {
        //           id: 'department-wise-consumption',
        //           label: 'Department Wise Consumption',
        //           to: '/hospital/store-management/department-wise-consumption'
        //         },
        //         {
        //           id: 'good-reciept-note',
        //           label: 'Good Reciept Note[GRN]',
        //           to: '/hospital/store-management/good-reciept-note'
        //         },
        //         {
        //           id: 'purchase-return',
        //           label: 'Purchase Return',
        //           to: '/hospital/store-management/purchase-return'
        //         },
        //         {
        //           id: 'purchase-authorize',
        //           label: 'Purchase Authorize',
        //           to: '/hospital/store-management/purchase-authorize'
        //         },
        //         {
        //           id: 'product-details',
        //           label: 'Product Details',
        //           to: '/hospital/store-management/product-details'
        //         },
        //         {
        //           id: 'warehouse-stock-transfer-request',
        //           label: 'Warehouse Stock Transfer Request',
        //           to: '/hospital/inventory/warehouse-stock-transfer-request'
        //         },
        //         {
        //           id: 'stock-transfer-voucher',
        //           label: 'Stock Transfer Voucher',
        //           to: '/hospital/inventory/stock-transfer-voucher'
        //         },
        //         {
        //           id: 'stock-transfer-acceptance',
        //           label: 'Stock Transfer Acceptance',
        //           to: '/hospital/inventory/stock-transfer-acceptance'
        //         },
        //         {
        //           id: 'stock-adjustment',
        //           label: 'Stock Adjustment',
        //           to: '/hospital/store-management/stock-adjustment'
        //         },
        //         {
        //           id: 'add-product-Detail',
        //           label: 'Add Product Detail',
        //           to: '/hospital/store-management/add-product-Detail'
        //         },

        //       ]
        //     },
        //     // {
        //     //   id: 'sale-transaction',
        //     //   label: 'Sale Transaction',
        //     //   img: TRANSACTION,
        //     //   children: [
        //     //     {
        //     //       id: 'sale-return',
        //     //       label: 'Sale Return',
        //     //       to: '/hospital/store-management/sale-return'
        //     //     },
        //     //     {
        //     //       id: 'retail-sale-pos',
        //     //       label: 'Retail Sale POS',
        //     //       to: '/hospital/store-management/retail-sale-pos'
        //     //     },
        //     //     {
        //     //       id: 'retail-sale-return',
        //     //       label: 'Retail Sale Return',
        //     //       to: '/hospital/store-management/retail-sale-return'
        //     //     }
        //     //   ]
        //     // },
        //     {
        //       id: 'report',
        //       label: 'Report',
        //       img: REPORT,
        //       children: [
        //         {
        //           id: 'master-report',
        //           label: 'Master Report',
        //           children: [
        //             {
        //               id: 'product-master-report',
        //               label: 'Product Master Report',
        //               to: '/hospital/inventory/product-master-report'
        //             },
        //             {
        //               id: 'product-master-report-excel',
        //               label: 'Product Master Report Excel',
        //               to: '/hospital/inventory/product-master-report-excel'
        //             }
        //           ]
        //         },
        //         {
        //           id: 'product-ledger',
        //           label: 'Product Legder',
        //           to: '/hospital/inventory/product-ledger'
        //         },
        //         {
        //           id: 'product-tracking-report',
        //           label: 'Product tracking Report',
        //           to: '/hospital/inventory/product-tracking-report'
        //         },
        //         {
        //           id: 'purchase-requisition-report',
        //           label: 'Purchase Requisition Report',
        //           to: '/hospital/inventory/purchase-requisition-report'
        //         },
        //         {
        //           id: 'purchase-order-report',
        //           label: 'Purchase Order Report',
        //           to: '/hospital/inventory/purchase-order-report'
        //         },
        //         {
        //           id: 'purchase-summary',
        //           label: 'Purchase Summary',
        //           to: '/hospital/inventory/purchase-summary'
        //         },
        //         {
        //           id: 'grn-report',
        //           label: 'GRN Reports',
        //           to: '/hospital/inventory/grn-report'
        //         },
        //         {
        //           id: 'purchase-return-report',
        //           label: 'Purchase Return Report',
        //           to: '/hospital/inventory/purchase-return-report'
        //         },
        //         {
        //           id: 'stock-transfer-report',
        //           label: 'Stock Transfer Report',
        //           children: [
        //             {
        //               id: 'stock-transfer-request-report',
        //               label: 'Stock Transfer Request Report',
        //               to: '/hospital/inventory/stock-transfer-request-report'
        //             },
        //             {
        //               id: 'stock-transfer-report',
        //               label: 'Stock Transfer  Report',
        //               to: '/hospital/inventory/stock-transfer-report'
        //             },
        //             {
        //               id: 'stock-transfer-accept-report',
        //               label: 'Stock Transfer Accept Report',
        //               to: '/hospital/inventory/stock-transfer-accept-report'
        //             }
        //           ]
        //         },
        //         {
        //           id: 'stock-reports',
        //           label: 'Stock Reports',
        //           children: [
        //             {
        //               id: 'stock-transfer-form',
        //               label: 'Stock Transfer Form',
        //               to: '/hospital/inventory/stock-transfer-form'
        //             },
        //             {
        //               id: 'stock-status',
        //               label: 'Stock Status',
        //               to: '/hospital/inventory/stock-status'
        //             },
        //             {
        //               id: 'stock-transfer-report',
        //               label: 'Stock Transfer Report',
        //               to: '/hospital/inventory/stock-transfer-report'
        //             },
        //             {
        //               id: 'stock-adjutment-report',
        //               label: 'Stock Adjument Report',
        //               to: '/hospital/inventory/stock-adjutment-report'
        //             },
        //             {
        //               id: 'warehouse-report',
        //               label: 'Warehouse Report',
        //               to: '/hospital/inventory/warehouse-report'
        //             },

        //           ]
        //         },
        //         {
        //           id: 'batch-wise-reports',
        //           label: 'Batch Wise Reports',
        //           children: [
        //             {
        //               id: 'batch-wise-item-transaction',
        //               label: 'Batch Wise Item Transaction',
        //               to: '/hospital/inventory/batch-wise-item-transaction'
        //             },
        //             {
        //               id: 'batch-wise-expired-item',
        //               label: 'Batch Wise Expired Item',
        //               to: '/hospital/inventory/batch-wise-expired-item'
        //             },
        //             {
        //               id: 'batch-wise-near-expiring-item',
        //               label: 'Batch Wise Near Expired Item',
        //               to: '/hospital/inventory/batch-wise-near-expiring-item'
        //             }
        //           ]
        //         }
        //       ]
        //     }
        //     // {
        //     //   id: 'analysis_report',
        //     //   label: 'Analysis Report',
        //     //   img: REPORT,
        //     //   children: [
        //     //     {
        //     //       id: 'location-wise-stock-summary',
        //     //       label: 'Location Wise Stock Summary',
        //     //       to: '/hospital/inventory/location-wise-stock-summary'
        //     //     },
        //     //     {
        //     //       id: 'monthly-stock-movement-analysis',
        //     //       label: 'Monthly Stock Movement Analysis',
        //     //       to: '/hospital/inventory/monthly-stock-movement-analysis'
        //     //     },
        //     //     {
        //     //       id: 'update-batch-no',
        //     //       label: 'Update Batch No./Packing Conversion',
        //     //       to: '/hospital/inventory/update-batch-no'
        //     //     }
        //     //   ]
        //     // }
        //     // {
        //     //   id: 'Utility',
        //     //   label: 'Utility',
        //     //   img: UTILITY,
        //     //   children: [
        //     //     {
        //     //       id: 'update-product-expiry-date',
        //     //       label: 'Update Product Expiry Date',
        //     //       to: '/hospital/inventory/update-product-expiry-date'
        //     //     },
        //     //     {
        //     //       id: 'update-cost-price',
        //     //       label: 'Update Cost Price ',
        //     //       to: '/hospital/inventory/update-cost-price'
        //     //     },
        //     //     {
        //     //       id: 'calculator',
        //     //       label: 'Calculator',
        //     //       to: '/hospital/inventory/calculator'
        //     //     },
        //     //     {
        //     //       id: 'change-company',
        //     //       label: 'Change Company',
        //     //       to: '/hospital/inventory/change-company'
        //     //     },
        //     //     {
        //     //       id: 'change-session',
        //     //       label: 'Change Session',
        //     //       to: '/hospital/inventory/change-session'
        //     //     },
        //     //     {
        //     //       id: 'login-information',
        //     //       label: 'Login Information',
        //     //       to: '/hospital/inventory/login-information'
        //     //     }
        //     //   ]
        //     // }
        //   ]
        // },
        {
          id: 'emr',
          label: 'EMR',
          img: OPDCLINICALMANAGEMENT,
          to: '/emr/opd-requisition',
          menu: [
            {
              id: 'opd-requisition',
              label: 'Opd Requisition',
              img: DB,
              children: [
                {
                  id: 'opd-requisition',
                  label: 'Opd Requisition',
                  to: '/hospital/emr/opd-requisition'
                }
              ]
            }
          ]
        },
        {
          id: 'tally',
          label: 'Tally',
          img: TALLY,
          to: '/tally',
          menu: [
            {
              id: 'master',
              label: 'Master',
              img: DB,
              children: [
                {
                  id: 'account-group-type',
                  label: 'Account Group Type',
                  to: '/hospital/tally/account-group-type'
                },
                {
                  id: 'account-group',
                  label: 'Account Group',
                  to: '/hospital/tally/account-group'
                },
                {
                  id: 'account-legder',
                  label: 'Account Ledger',
                  to: '/hospital/tally/account-ledger'
                },
                // {
                //   id: 'import-account-ledger',
                //   label: 'Import Account Ledger',
                //   to: '/hospital/tally/import-account-ledger'
                // },
                // {
                //   id: 'request-for-new-supplier-customer',
                //   label: 'Request For New Supplier Customer',
                //   to: '/hospital/tally/request-for-new-supplier-customer'
                // },
                // {
                //   id: 'tax-charge-discount',
                //   label: 'Tax Charge Discount',
                //   to: '/hospital/tally/tax-charge-discount'
                // },
                // {
                //   id: 'online-customer-registration',
                //   label: 'Online Customer Registration',
                //   to: '/hospital/tally/online-customer-registration'
                // },
                {
                  id: 'cost-center-type-master',
                  label: 'Cost Center Type Master',
                  to: '/hospital/tally/cost-center-type-master'
                },
                {
                  id: 'cost-center-master',
                  label: 'Cost Center Master',
                  to: '/hospital/tally/cost-center-master'
                },
                {
                  id: 'analysis-master',
                  label: 'Analysis Master',
                  to: '/hospital/tally/analysis-master'
                },
                {
                  id: 'sub-analysis-master',
                  label: 'Sub Analysis Master',
                  to: '/hospital/tally/sub-analysis-master'
                },
                {
                  id: 'expense-head-master',
                  label: 'Expense Head Master',
                  to: '/hospital/tally/expense-head-master'
                },
                {
                  id: 'doctor-share-setup-master',
                  label: 'Doctor Share Setup Master',
                  to: '/hospital/tally/doctor-share-setup-master'
                },

              ]
            },
            {
              id: 'transaction',
              label: 'Transaction',
              img: TRANSACTION,
              children: [
                {
                  id: 'purchase-invoice',
                  label: 'Purchase Invoice',
                  to: '/hospital/tally/purchase-invoice'
                },
                {
                  id: 'supplier-service-invoice',
                  label: 'Supplier Service Invoice',
                  to: '/hospital/tally/supplier-service-invoice'
                },
                {
                  id: 'debit-credit-note',
                  label: 'Debit Credit Note',
                  to: '/hospital/tally/debit-cedit-note'
                },
                {
                  id: 'patient-receipt-voucher',
                  label: 'Patient Receipt Voucher ',
                  to: '/hospital/tally/patient-receipt-voucher'
                },
                {
                  id: 'retail-cash-voucher',
                  label: 'Retail Cash Voucher',
                  to: '/hospital/tally/retail-cash-voucher'
                },
                {
                  id: 'supplier-payment-voucher',
                  label: 'Supplier Payment Voucher',
                  to: '/hospital/tally/supplier-payment-voucher'
                },
                {
                  id: 'customer-receipt-voucher',
                  label: 'Customer Receipt  Voucher',
                  to: '/hospital/tally/customer-receipt-voucher'
                },
                {
                  id: 'receipt-voucher',
                  label: ' Receipt  Voucher',
                  to: '/hospital/tally/receipt-voucher'
                },
                {
                  id: 'payment-voucher',
                  label: 'Payment  Voucher',
                  to: '/hospital/tally/payment-voucher'
                },
                {
                  id: 'journal-voucher',
                  label: 'Journal  Voucher',
                  to: '/hospital/tally/journal-voucher'
                },
                {
                  id: 'contra-voucher',
                  label: 'Contra Voucher',
                  to: '/hospital/tally/contra-voucher'
                },
                {
                  id: 'bank-reconciliation',
                  label: 'Bank Reconciliation',
                  to: '/hospital/tally/bank-reconciliation'
                },
                {
                  id: 'adjustment-voucher',
                  label: ' Adjustment  Voucher',
                  to: '/hospital/tally/adjustment-voucher'
                },
                {
                  id: 'bulk-authorization',
                  label: 'Bulk Authorization',
                  to: '/hospital/tally/bulk-authorization'
                },
                {
                  id: 'expense-entry',
                  label: 'Expense Entry',
                  to: '/hospital/tally/expense-entry'
                },
                {
                  id: 'suppllier-payment-voucher',
                  label: 'Suppllier Payment Voucher',
                  to: '/hospital/tally/suppllier-payment-voucher'
                },
                {
                  id: 'bill-wise-ledger-opening-balance',
                  label: 'Bill Wise Ledger Opening balance',
                  to: '/hospital/tally/bill-wise-ledger-opening-balance'
                },
                {
                  id: 'doctor-share-audit',
                  label: 'Doctor Share Audit',
                  to: '/hospital/tally/doctor-share-audit'
                },
                {
                  id: 'patient-refund-voucher',
                  label: 'Patient Refund Voucher',
                  to: '/hospital/tally/patient-refund-voucher'
                },

              ]
            },
            {
              id: 'report',
              label: 'Report',
              img: REPORT,
              children: [
                {
                  id: 'gst-report',
                  label: 'Gst Reports',
                  to: '/hospital/tally/gst-report'
                },
                {
                  id: 'day-book',
                  label: 'Day Book ',
                  to: '/hospital/tally/day-book'
                },
                {
                  id: 'cash-book',
                  label: 'Cash Book',
                  to: '/hospital/tally/cash-book'
                },
                {
                  id: 'bank-book',
                  label: 'Bank Book',
                  to: '/hospital/tally/bank-book'
                },
                {
                  id: 'ledger',
                  label: 'Ledger',
                  to: '/hospital/tally/ledger'
                },
                {
                  id: 'trail-balance',
                  label: 'Trail Balance',
                  to: '/hospital/tally/trail-balance'
                },
                {
                  id: 'profit-loss',
                  label: 'Profit & Loss',
                  to: '/hospital/tally/profit-loss'
                },
                {
                  id: 'balance-sheet',
                  label: 'Balance Sheet',
                  to: '/hospital/tally/balance-sheet'
                },
                {
                  id: 'customer-outstanding',
                  label: 'Customer Outstanding',
                  to: '/hospital/tally/customer-outstanding'
                },
                {
                  id: 'gst-report',
                  label: 'Gst Report',
                  to: '/hospital/tally/gst-report'
                },
                {
                  id: 'receipt-voucher-report',
                  label: 'Receipt Voucher Report',
                  to: '/hospital/tally/receipt-voucher-report'
                },
                {
                  id: 'payment-voucher-report',
                  label: 'Payment Vocuher Report',
                  to: '/hospital/tally/payment-voucher-report'
                },
                {
                  id: 'journal-voucher-report',
                  label: 'Journal Vocuher Report',
                  to: '/hospital/tally/journal-voucher-report'
                },
                {
                  id: 'bank-reconcilation-report',
                  label: 'Bank Reconcilation Report',
                  to: '/hospital/tally/bank-reconcilation-report'
                }
              ]
            },
            {
              id: 'Utility',
              label: 'Utility',
              img: UTILITY,
              children: [
                {
                  id: 'cost-account-mapping',
                  label: 'Cost Account Mapping',
                  to: '/hospital/tally/cost-account-mapping'
                },
                {
                  id: 'sub-analysis-mapping',
                  label: 'Sub Analysis Mapping',
                  to: '/hospital/tally/sub-analysis-mapping'
                },
                {
                  id: 'finance-group',
                  label: 'Finance Group',
                  to: '/hospital/tally/finance-group'
                }
              ]
            }
          ]
        },
        // {
        //   id: 'mrd',
        //   label: 'MRD',
        //   img: MRD,
        //   to: '/mrd',
        //   menu: [
        //     {
        //       id: 'master',
        //       label: 'Master',
        //       img: DB,
        //       children: [
        //         {
        //           id: 'diagnosis-master',
        //           label: 'Diagnosis Master',
        //           children: [
        //             {
        //               id: 'diagnosis-group-master',
        //               label: 'Diagnosis Group Master',
        //               to: '/hospital/mrd/diagnosis-group-master'
        //             },
        //             {
        //               id: 'diagnosis-sub-group-master',
        //               label: 'Diagnosis Sub  Group Master',
        //               to: '/hospital/mrd/diagnosis-sub-group-master'
        //             },
        //             {
        //               id: 'diagnosis-master',
        //               label: 'Diagnosis  Master',
        //               to: '/hospital/mrd/diagnosis-master'
        //             }
        //           ]
        //         },
        //         {
        //           id: 'deficiency-checklist-master',
        //           label: 'Deficiency Checklist Master',
        //           to: '/hospital/mrd/deficiency-checklist-master'
        //         },
        //         {
        //           id: 'icp-group-master',
        //           label: 'ICP Group Master',
        //           to: '/hospital/mrd/icp-group-master'
        //         },
        //         {
        //           id: 'icp-subgroup-master',
        //           label: 'ICP Sub Group Master',
        //           to: '/hospital/mrd/icp-subgroup-master'
        //         },
        //         {
        //           id: 'icp-diagnosis-master',
        //           label: 'ICP Diagnosis Master',
        //           to: '/hospital/mrd/icp-diagnosis-master'
        //         },
        //         {
        //           id: 'zone-master',
        //           label: 'Zone Master',
        //           to: '/hospital/mrd/zone-master'
        //         },
        //         {
        //           id: 'bin-master',
        //           label: 'Bin Master',
        //           to: '/hospital/mrd/bin-master'
        //         },
        //         {
        //           id: 'junior-resident-master',
        //           label: 'Junior Resident Master',
        //           to: '/hospital/mrd/junior-resident-master'
        //         },
        //         {
        //           id: 'mlc-type-master',
        //           label: 'MLC Type Master',
        //           to: '/hospital/mrd/mlc-type-master'
        //         },

        //       ]
        //     },
        //     {
        //       id: 'transaction',
        //       label: 'Transaction',
        //       img: TRANSACTION,
        //       children: [
        //         {
        //           id: 'deficiency-checklist',
        //           label: 'Deficiency Checklist',
        //           to: '/hospital/mrd/deficiency-checklist'
        //         },
        //         {
        //           id: 'mrd-reciept-voucher',
        //           label: 'MRD Reciept Voucher',
        //           to: '/hospital/mrd/mrd-receipt-voucher'
        //         },
        //         {
        //           id: 'mrd-reciept-voucher-status-update',
        //           label: 'MRD Receipt Vocuher Update Status',
        //           to: '/hospital/mrd/mrd-receipt-voucher-update-status'
        //         },
        //         {
        //           id: 'file-requisition',
        //           label: 'File Requisition',
        //           to: '/hospital/mrd/file-requisition'
        //         },
        //         {
        //           id: 'file-issue',
        //           label: 'File Issue',
        //           to: '/hospital/mrd/file-issue'
        //         },
        //         {
        //           id: 'file-return',
        //           label: 'File Return',
        //           to: '/hospital/mrd/file-return'
        //         },
        //         {
        //           id: 'ipd-patient-diagnosis',
        //           label: 'IPD Patient Diagnosis',
        //           to: '/hospital/mrd/ipd-patient-diagnosis'
        //         },
        //         {
        //           id: 'opd-artificial-manual-override',
        //           label: 'Opd Atificial Manual Override',
        //           to: '/hospital/mrd/opd-artificial-manual-override'
        //         },
        //         {
        //           id: 'ipd-artificial-manual-override',
        //           label: 'Ipd Atificial Manual Override',
        //           to: '/hospital/mrd/ipd-artificial-manual-override'
        //         },
        //         {
        //           id: 'bed-occupy-percentage-status',
        //           label: 'Bed Occupy Percentage Status',
        //           to: '/hospital/mrd/bed-occupy-percentage-status'
        //         },
        //       ]
        //     },
        //     {
        //       id: 'report',
        //       label: 'Report',
        //       img: DB,
        //       children: [
        //         {
        //           id: 'mrd-file-reciept-report',
        //           label: 'MRD File Reciept Report',
        //           to: '/hospital/mrd/mrd-file-reciept-report'
        //         },
        //         {
        //           id: 'mrd-file-tracking-report',
        //           label: 'MRD File Tracking Report',
        //           to: '/hospital/mrd/mrd-file-tracking-report'
        //         },
        //         {
        //           id: 'mrd-file-status-report',
        //           label: 'MRD File Status Report',
        //           to: '/hospital/mrd/mrd-file-status-report'
        //         }
        //       ]
        //     }
        //   ]
        // },
        {
          id: 'mrd',
          label: 'MRD',
          img: MRD,
          to: '/mrd',
          menu: [
            {
              id: 'master',
              label: 'Master',
              img: DB, 
              children: [
                {
                  id: 'dashboard',
                  label: 'Dashboard',
                  to: '/hospital/mrd/dashboard'
                },
                {
                  id: 'master-data',
                  label: 'Master Data',
                  to: '/hospital/mrd/master'
                },
                {
                  id: 'mrd-files',
                  label: 'MRD Files',
                  to: '/hospital/mrd/mrd-files'
                },
                // {
                //   id: 'settings',
                //   label: 'Settings',
                //   to: '/hospital/mrd/settings'
                // }
              ]
            },
            {
              id: 'transaction',
              label: 'Transaction',
              img: TRANSACTION,
              children: [
                {
                  id: 'coding',
                  label: 'Medical Coding',
                  to: '/hospital/mrd/coding'
                },
                // {
                //   id: 'deficiency',
                //   label: 'Deficiency Management',
                //   to: '/hospital/mrd/deficiency' // You might want to adjust this if it needs a fileId
                // },
                // {
                //   id: 'documents',
                //   label: 'Documents',
                //   to: '/hospital/mrd/documents' // You might want to adjust this if it needs a fileId
                // },
                // {
                //   id: 'movement',
                //   label: 'File Movement',
                //   to: '/hospital/mrd/movement'
                // },
                {
                  id: 'requests',
                  label: 'Requests',
                  to: '/hospital/mrd/requests'
                },
                {
                  id: 'closure',
                  label: 'Closure',
                  to: '/hospital/mrd/closure'
                }
              ]
            },
            {
              id: 'report',
              label: 'Reports',
              img: DB,
              children: [
                // {
                //   id: 'reports',
                //   label: 'Reports Dashboard',
                //   to: '/hospital/mrd/reports'
                // },
                {
                  id: 'overdue-deficiencies',
                  label: 'Overdue Deficiencies',
                  to: '/hospital/mrd/reports/overdue-deficiencies'
                },
                {
                  id: 'deficiency-statistics',
                  label: 'Deficiency Statistics',
                  to: '/hospital/mrd/reports/deficiency-statistics'
                },
                {
                  id: 'archive',
                  label: 'Archive Reports',
                  to: '/hospital/mrd/archive'
                }
              ]
            }
          ]
        },
        {
          id: 'pacs',
          label: 'Pacs',
          img: PACS,
          to: '/pacs',
          menu: [
            {
              id: 'setup',
              label: 'Set Up',
              img: DB,
              children: [
                {
                  id: 'system-parameter',
                  label: 'System Parameter',
                  to: '/hospital/admin/system-parameter'
                },
                {
                  id: 'system-parameter-hms',
                  label: 'System Parameter HMS',
                  to: '/hospital/admin/system-parameter-hms'
                },
                {
                  id: 'system-parameter-lis',
                  label: 'System Parameter LIS',
                  to: '/hospital/admin/system-parameter-lis'
                },
                {
                  id: 'ware-house-mapping',
                  label: 'Ware House Mapping',
                  to: '/hospital/admin/ware-house-mapping'
                },
                {
                  id: 'multi-level-authorization',
                  label: 'Multi Level Authorization',
                  to: '/hospital/admin/multi-level-authorization'
                },
                {
                  id: 'user-rights-report',
                  label: 'User Rights Report',
                  to: '/hospital/admin/user-right-report'
                },
                {
                  id: 'voucher-series-setup',
                  label: 'Voucher Series Setup',
                  to: '/hospital/admin/voucher-series-setup'
                },
                {
                  id: 'mobile-device-user-setup',
                  label: 'Mobile Device User Setup',
                  to: '/hospital/admin/mobile-device-user-setup'
                },
                {
                  id: 'invoice-configuration',
                  label: 'Invoice Configuration',
                  to: '/hospital/admin/invoice-configuration'
                },
                {
                  id: 'reports-name-parameter',
                  label: 'Reports Name Parameter',
                  to: '/hospital/admin/reports-name-parameter'
                },
                {
                  id: 'pending-order-update',
                  label: 'Pending Order Update',
                  to: '/hospital/admin/pending-order-update'
                },
                {
                  id: 'sales-location',
                  label: 'Sales Location',
                  to: '/hospital/admin/sales-location'
                },
                {
                  id: 'multi-level-authorization-hms',
                  label: 'Multi Level Authorization HMS',
                  to: '/hospital/admin/multi-level-authorization-hms'
                },
                {
                  id: 'remote-customer-mapping',
                  label: 'Remote Customer Mapping',
                  to: '/hospital/admin/remote-customer-mapping'
                },
                {
                  id: 'shift-master',
                  label: 'Shift Master',
                  to: '/hospital/admin/shift-master'
                },
                {
                  id: 'user-wise-shift-mapping',
                  label: 'User Wise Shift Mapping',
                  to: '/hospital/admin/user-wise-shift-mapping'
                },
                {
                  id: 'city-master',
                  label: 'City Master',
                  to: '/hospital/admin/city-master'
                },
                {
                  id: 'user-wise-product-type-mapping',
                  label: 'User Wise Product Type Mapping',
                  to: '/hospital/admin/user-wise-prdouct-type-mapping'
                }
              ]
            },
            {
              id: 'Role & Permissions',
              label: 'Role & Permissions',
              img: DB,
              children: [
                {
                  id: 'user-department-master',
                  label: 'User Department Master',
                  to: '/hospital/admin/user-department-master'
                },
                {
                  id: 'role',
                  label: 'Roles',
                  to: '/hospital/admin/role'
                },
                {
                  id: 'role-permissions',
                  label: 'Role Permissions',
                  to: '/hospital/admin/role-permissions'
                },
                {
                  id: 'user-management',
                  label: 'User Management',
                  to: '/hospital/admin/user-management'
                },
                {
                  id: 'menu',
                  label: 'menu',
                  to: '/hospital/admin/menu'
                }
              ]
            },
            {
              id: 'import-data',
              label: 'Import Data',
              img: DB,
              children: [
                {
                  id: 'pervice-import-data',
                  label: 'Service Master Import Data',
                  to: '/hospital/admin/service-import-data'
                },
                {
                  id: 'doctor-import-data',
                  label: 'Doctor Import Data',
                  to: '/hospital/admin/doctor-import-data'
                },
                {
                  id: 'sponser-import-data',
                  label: 'Sponser Import Data',
                  to: '/hospital/admin/sponser-import-data'
                },
                {
                  id: 'patient-import-data',
                  label: 'Patient Import Data',
                  to: '/hospital/admin/patient-import-data'
                },
                {
                  id: 'product-master-import-data',
                  label: 'Product Master Import Data',
                  to: '/hospital/admin/product-master-import-data'
                },
                {
                  id: 'test-item-master-import-data',
                  label: 'Test Item Master Import Data',
                  to: '/hospital/admin/test-item-master-import-data'
                },
                {
                  id: 'test-master-import-data',
                  label: 'Test Master Import Data',
                  to: '/hospital/admin/test-master-import-data'
                },
                {
                  id: 'opd-billing-import-data',
                  label: 'Opd Billing Import Data',
                  to: '/hospital/admin/opd-billing-import-data'
                },
                {
                  id: 'ipd-billing-import-data',
                  label: 'Ipd Billing Import Data',
                  to: '/hospital/admin/ipd-billing-import-data'
                }
              ]
            }
          ]
        },
        {
          id: 'third-party-insurance',
          label: 'Tpa',
          img: TPA,
          to: '/tpa',
          menu: [
            {
              id: 'transaction',
              label: 'Transaction',
              img: DB,
              children: [
                // {
                //   id: 'tpa-receipt-voucher',
                //   label: 'TPA Receipt Voucher',
                //   to: '/hospital/tpa/tpa-receipt-voucher'
                // },
                {
                  id: 'echs-referral',
                  label: 'ECHS Referral',
                  to: '/hospital/tpa/echs-referral'
                },
                {
                  id: 'tpa-billing',
                  label: 'TPA Billing',
                  to: '/hospital/tpa/tpa-billing'
                },
                {
                  id: 'tpa-claim-amount',
                  label: 'TPA Claim Amount',
                  to: '/hospital/tpa/tpa-claim-amount'
                }
              ]
            },
            {
              id: 'reports',
              label: 'Reports',
              img: DB,
              children: [
                {
                  id: 'tpa-claim-amount-status-reports',
                  label: 'TPA Claim Amount Status Reports',
                  to: '/hospital/tpa/tpa-claim-amount-status-report'
                },
              ]
            }
          ]
        },
        {
          id: 'cssd',
          label: 'CSSD',
          img: CSSD,
          to: '/cssd',
          menu: [
            {
              id: 'master',
              label: 'Masters',
              img: DB,
              children: [
                {
                  id: 'tray-assemble',
                  label: 'Tray Assemble',
                  to: '/hospital/cssd/tray-assemble'
                }
              ]
            },
            {
              id: 'Transactions',
              label: 'Transaction',
              img: DB,
              children: [
                {
                  id: 'tray-request',
                  label: 'Tray Request',
                  to: '/hospital/cssd/tray-request'
                },
                {
                  id: 'tray-sterilized',
                  label: 'Tray Sterilized',
                  to: '/hospital/cssd/tray-sterilized'
                }
              ]
            }
          ]
        },
        {
          id: 'biomedical-engg',
          label: 'Bio-medical Engg.',
          img: EQUIMENTMAINTENACE,
          to: '/biomedical-engg',
          menu: [
            {
              id: 'setup',
              label: 'Set Up',
              img: DB,
              children: [
                {
                  id: 'system-parameter',
                  label: 'System Parameter',
                  to: '/hospital/admin/system-parameter'
                },
              ]
            },
          ]
        },
        {
          id: 'doctor-management',
          label: 'Doctor Management',
          img: DOCTORMANAGEMENT,
          to: '/doctor-management',
          menu: [
            {
              id: 'master',
              label: 'Master',
              img: DB,
              children: [
                {
                  id: 'frequency-master',
                  label: 'Frequency Master',
                  to: '/hospital/doctor-management/frequency-master'
                },
                {
                  id: 'dose-master',
                  label: 'Dose Master',
                  to: '/hospital/doctor-management/dose-master'
                }
              ]
            },
            {
              id: 'transaction',
              label: 'Transaction',
              img: TRANSACTION,
              children: [
                // {
                //   id: 'indent-requisition-form',
                //   label: 'Indent Requsition Form',
                //   to: '/hospital/doctor-management/indent-requisiton-form'
                // },
                // {
                //   id: 'test-result',
                //   label: 'View Test Result',
                //   to: '/hospital/doctor-management/test-result'
                // },
                {
                  id: 'view-result',
                  label: 'View  Result',
                  to: '/hospital/doctor-management/view-result'
                },
                {
                  id: 'patient-discharge-request',
                  label: 'Patient Discharge Request',
                  to: '/hospital/doctor-management/patient-discharge-request'
                },
                {
                  id: 'discharge-summary',
                  label: 'Discharge Summary',
                  to: '/hospital/doctor-management/discharge-summary'
                },
                {
                  id: 'opd-requisition',
                  label: 'Opd Requisition',
                  to: '/hospital/doctor-management/opd-requisition'
                },
                {
                  id: 'ipd-requisition',
                  label: 'Ipd Requisition',
                  to: '/hospital/doctor-management/ipd-requisition'
                },
                {
                  id: 'view-doctor-visits-and-bills',
                  label: 'View Doctor Visits and Bills',
                  to: '/hospital/doctor-management/view-doctor-visits-and-bills'
                },
              ]
            },
            {
              id: 'reports',
              label: 'Reports',
              img: REPORT,
              children: [
                {
                  id: 'doctor-ledger-report',
                  label: 'Doctor Ledger Reports',
                  to: '/hospital/doctor-management/doctor-ledger-report'
                },

              ]
            },
          ]
        },
       
        {
          id: 'hr-management',
          label: 'Hr Management',
          img: HR,
          to: '/hr-management',
          menu: [
            {
              id: 'master',
              label: 'Master',
              img: DB,
              children: [
                {
                  id: 'payrole-item',
                  label: 'Pay Role Item',
                  to: '/hospital/hr-management/payroleitem'
                }
              ]
            },
            {
              id: 'transaction',
              label: 'Transaction',
              img: DB,
              children: [
                {
                  id: 'employee-management',
                  label: 'Employee Management',
                  to: '/hospital/hr-management/employee-management'
                },
                {
                  id: 'employee-attendance',
                  label: 'Employee Attendance',
                  to: '/hospital/hr-management/employee-attendance'
                },
                {
                  id: 'generate-salary-slip',
                  label: 'Generate Salary Slip',
                  to: '/hospital/hr-management/generate-salary-slip'
                }
              ]
            }
          ]
        },
        {
          id: 'abdm',
          label: 'Abdm',
          img: DISCHARGESUMMARY,
          to: '/abdm',
          menu: [
            {
              id: 'transaction',
              label: 'Transaction',
              img: DB,
              children: [
                {
                  id: 'adbm-form',
                  label: 'ABDM',
                  to: '/hospital/abdm/abdm-form'
                }
              ]
            }
          ]
        },
        {
          id: 'housekeeping-and-linen-management',
          label: 'House Keeping Management',
          img: HOUSEKEEPING,
          to: '/housekeeping-and-linen-management',
          menu: [
            {
              id: 'housekeeping',
              label: 'Housekeeping',
              img: DB,
              children: [
                {
                  id: 'dashboard',
                  label: 'Dashboard',
                  to: '/hospital/housekeeping-and-linen-management/housekeeping/dashboard'
                },
                {
                  id: 'Master',
                  label: 'Master',
                  img: DB,
                  children: [
                    {
                      id: 'checklist',
                      label: 'Checklist',
                      to: '/hospital/housekeeping-and-linen-management/housekeeping/checklist'
                    },
                    {
                      id: 'staff',
                      label: 'Staff',
                      to: '/hospital/housekeeping-and-linen-management/housekeeping/staff'
                    }
                  ]
                },
                {
                  id: 'Transaction',
                  label: 'Transaction',
                  img: DB,
                  children: [
                    {
                      id: 'task-create',
                      label: 'Task Create',
                      to: '/hospital/housekeeping-and-linen-management/housekeeping/task-create'
                    },
                    {
                      id: 'task-list',
                      label: 'Task List',
                      to: '/hospital/housekeeping-and-linen-management/housekeeping/task-list'
                    }
                  ]
                },
                {
                  id: 'report',
                  label: 'Report',
                  img: DB,
                  children: [
                    {
                      id: 'audit-create',
                      label: 'Audit Create',
                      to: '/hospital/housekeeping-and-linen-management/housekeeping/audit-create'
                    },
                    {
                      id: 'audit-list',
                      label: 'Audit List',
                      to: '/hospital/housekeeping-and-linen-management/housekeeping/audit-list'
                    },
                    // {
                    //   id: 'task-detail',
                    //   label: 'Task Details',
                    //   to: '/hospital/housekeeping-and-linen-management/housekeeping/task-detail'
                    // }
                  ]
                }
              ]
            },
            {
              id: 'linen',
              label: 'Linen',
              img: DB,
              children: [
                {
                  id: 'dashboard',
                  label: 'Dashboard',
                  to: '/hospital/housekeeping-and-linen-management/linen/dashboard'
                },
                {
                  id: 'Master',
                  label: 'Master',
                  img: DB,
                  children: [
                    {
                      id: 'linen-item',
                      label: 'Items',
                      to: '/hospital/housekeeping-and-linen-management/linen/linen-item'
                    },
                    {
                      id: 'linen-vendor',
                      label: 'Vendors',
                      to: '/hospital/housekeeping-and-linen-management/linen/linen-vendor'
                    }
                  ]
                },
                {
                  id: 'Transaction',
                  label: 'Transaction',
                  img: DB,
                  children: [
                    {
                      id: 'linen-issue',
                      label: 'Issue',
                      to: '/hospital/housekeeping-and-linen-management/linen/linen-issue'
                    },
                    {
                      id: 'linen-issue-list',
                      label: 'Issue List',
                      to: '/hospital/housekeeping-and-linen-management/linen/linen-issue-list'
                    },
                    {
                      id: 'linen-dispatch',
                      label: 'Dispatch',
                      to: '/hospital/housekeeping-and-linen-management/linen/linen-dispatch'
                    },
                    {
                      id: 'linen-dispatch-list',
                      label: 'Dispatch List',
                      to: '/hospital/housekeeping-and-linen-management/linen/linen-dispatch-list'
                    },
                    {
                      id: 'linen-receive',
                      label: 'Receive',
                      to: '/hospital/housekeeping-and-linen-management/linen/linen-receive'
                    },
                    {
                      id: 'linen-receive-list',
                      label: 'Receive List',
                      to: '/hospital/housekeeping-and-linen-management/linen/linen-receive-list'
                    },
                  ]
                },
                {
                  id: 'report',
                  label: 'Report',
                  img: DB,
                  children: [
                    {
                      id: 'linen-daily-report',
                      label: 'Daily Report',
                      to: '/hospital/housekeeping-and-linen-management/linen/linen-daily-report'
                    },
                    {
                      id: 'ward-consumption',
                      label: 'Ward Consumption',
                      to: '/hospital/housekeeping-and-linen-management/linen/ward-consumption'
                    }
                  ]
                },
                {
                  id: 'linen-history',
                  label: 'Linen History',
                  to: '/hospital/housekeeping-and-linen-management/linen/linen-history'
                }
              ]
            }
          ]
        },




        {
          id: 'diet-management',
          label: 'Diet Management',
          img: CANTEEN,
          to: '/diet-management',
          menu: [
            {
              id: 'Transaction',
              label: 'Transaction',
              img: DB,
              children: [
                {
                  id: 'diet-management',
                  label: 'Diet Management',
                  to: '/hospital/diet-management/diet-management'
                },
              ]
            },
            {
              id: 'Reports',
              label: 'Reports',
              img: DB,
              children: [
                {
                  id: 'diet-report',
                  label: 'Diet Report',
                  to: '/hospital/diet-management/diet-report'
                },
              ]
            }
          ]
        },
        {
          id: 'ambulance-management',
          label: 'Ambulance Management',
          img: AMBULANCE,
          to: '/ambulance-management',
          menu: []
        }
      ]
    },
    {
      id: 'pharmacy',
      label: 'Pharmacy',
      img: INV,
      to: '/pharmacy',
      options: [
        {
          id: 'inv',
          label: 'inv',
          img: INV,
          to: '/inventory',
          menu: [
            {
              id: 'master',
              label: 'Master',
              img: DB,
              children: [
                {
                  id: 'product-management',
                  label: 'Product Management',
                  children: [
                    {
                      id: 'uqc-master',
                      label: 'UQC Master',
                      to: '/pharmacy/inventory/uqc-master'
                    },
                    {
                      id: 'product-master',
                      label: 'Product Master',
                      to: '/pharmacy/inventory/product-master'
                    },
                    {
                      id: 'product-details',
                      label: 'Product Details ',
                      to: '/pharmacy/inventory/product-details'
                    }
                    // {
                    //   id: 'import-product-master',
                    //   label: 'Import Product Master',
                    //   to: '/pharmacy/inventory/import-product-master'
                    // },
                    // {
                    //   id: 'request-new-product',
                    //   label: 'Request For New Product',
                    //   to: '/pharmacy/inventory/request-new-product'
                    // },
                    // {
                    //   id: 'package-medicine-detail',
                    //   label: 'Package Medicine Detail',
                    //   to: '/pharmacy/inventory/package-medicine-detail'
                    // }
                  ]
                },
                {
                  id: 'storage-management',
                  label: 'Storage Management',
                  children: [
                    {
                      id: 'ware-house',
                      label: 'Ware House',
                      to: '/pharmacy/inventory/ware-house'
                    }
                  ]
                },
                {
                  id: 'tax-charge-discount',
                  label: 'Tax Charge Discount',
                  to: '/pharmacy/inventory/tax-charge-discount'
                },
                {
                  id: 'purchase-order-terms',
                  label: 'Purchase Order Terms ',
                  to: '/pharmacy/inventory/purchase-order-term'
                }
              ]
            },
            {
              id: 'transaction',
              label: 'Purchase Transaction',
              img: TRANSACTION,
              children: [
                {
                  id: 'procurement',
                  label: 'Procurement',
                  children: [
                    {
                      id: 'requisition',
                      label: 'Requisition',
                      to: '/pharmacy/inventory/requisition'
                    },
                    {
                      id: 'auto-generate-purchase-request',
                      label: 'Auto Generate Purchase Request',
                      to: '/pharmacy/inventory/auto-generate-purchase-request'
                    },
                    {
                      id: 'requisition-camcellation',
                      label: 'Requisition Cancellation',
                      to: '/pharmacy/inventory/requisition-cancellation'
                    },
                    {
                      id: 'request-quotation-from-supplier',
                      label: 'Request Qoutation From Supplier',
                      to: '/pharmacy/inventory/request-quotation-from-supplier'
                    },
                    {
                      id: 'purchase-qoutation',
                      label: 'Purchase Qoutation',
                      to: '/pharmacy/inventory/purchase-qoutation'
                    },
                    {
                      id: 'purchase-order',
                      label: 'Purchase Order',
                      to: '/pharmacy/inventory/purchase-order'
                    },
                    {
                      id: 'cancel-purchase-order',
                      label: 'cancel Purchase Order',
                      to: '/pharmacy/inventory/cancel-purchase-order'
                    }
                  ]
                },
                {
                  id: 'consigment-receipt',
                  label: 'Consigment Reciept',
                  to: '/pharmacy/inventory/consigment-receipt'
                },
                {
                  id: 'consignment-return',
                  label: 'Consigment Return',
                  to: '/pharmacy/inventory/consignment-return'
                },
                {
                  id: 'good-reciept-note',
                  label: 'Good Reciept Note[GRN]',
                  to: '/pharmacy/inventory/good-reciept-note'
                },
                {
                  id: 'purchase-return',
                  label: 'Purchase Return',
                  to: '/pharmacy/inventory/purchase-return'
                },
                {
                  id: 'purchase-authorize',
                  label: 'Purchase Authorize',
                  to: '/pharmacy/inventory/purchase-authorize'
                },
                {
                  id: 'product-details',
                  label: 'Product Details',
                  to: '/pharmacy/inventory/product-details'
                },
                {
                  id: 'warehouse-stock-transfer-request',
                  label: 'Warehouse Stock Transfer Request',
                  to: '/pharmacy/inventory/warehouse-stock-transfer-request'
                },
                {
                  id: 'stock-transfer-voucher',
                  label: 'Stock Transfer Voucher',
                  to: '/pharmacy/inventory/stock-transfer-voucher'
                },
                {
                  id: 'stock-transfer-acceptance',
                  label: 'Stock Transfer Acceptance',
                  to: '/pharmacy/inventory/stock-transfer-acceptance'
                },
                {
                  id: 'stock-adjustment',
                  label: 'Stock Adjustment',
                  to: '/pharmacy/inventory/stock-adjustment'
                }
              ]
            },
            {
              id: 'sale-transaction',
              label: 'Sale Transaction',
              img: DB,
              children: [
                {
                  id: 'sale-return',
                  label: 'Sale Return',
                  to: '/pharmacy/inventory/sale-return'
                },
                {
                  id: 'retail-sale-pos',
                  label: 'Retail Sale POS',
                  to: '/pharmacy/inventory/retail-sale-pos'
                },
                {
                  id: 'retail-sale-return',
                  label: 'Retail Sale Return',
                  to: '/pharmacy/inventory/retail-sale-return'
                }
              ]
            },
            {
              id: 'report',
              label: 'Report',
              img: REPORT,
              children: [
                {
                  id: 'master-report',
                  label: 'Master Report',
                  children: [
                    {
                      id: 'product-master-report',
                      label: 'Product Master Report',
                      to: '/pharmacy/inventory/product-master-report'
                    },
                    {
                      id: 'product-master-report-excel',
                      label: 'Product Master Report Excel',
                      to: '/pharmacy/inventory/product-master-report-excel'
                    }
                  ]
                },
                {
                  id: 'product-ledger',
                  label: 'Product Legder',
                  to: '/pharmacy/inventory/product-ledger'
                },
                {
                  id: 'product-tracking-report',
                  label: 'Product tracking Report',
                  to: '/pharmacy/inventory/product-tracking-report'
                },
                {
                  id: 'purchase-requisition-report',
                  label: 'Purchase Requisition Report',
                  to: '/pharmacy/inventory/purchase-requisition-report'
                },
                {
                  id: 'purchase-order-report',
                  label: 'Purchase Order Report',
                  to: '/pharmacy/inventory/purchase-order-report'
                },
                {
                  id: 'purchase-summary',
                  label: 'Purchase Summary',
                  to: '/pharmacy/inventory/purchase-summary'
                },
                {
                  id: 'grn-report',
                  label: 'GRN Reports',
                  to: '/pharmacy/inventory/grn-report'
                },
                {
                  id: 'purchase-return-report',
                  label: 'Purchase Return Report',
                  to: '/pharmacy/inventory/purchase-return-report'
                },
                {
                  id: 'stock-transfer-report',
                  label: 'Stock Transfer Report',
                  children: [
                    {
                      id: 'stock-transfer-request-report',
                      label: 'Stock Transfer Request Report',
                      to: '/pharmacy/inventory/stock-transfer-request-report'
                    },
                    {
                      id: 'stock-transfer-report',
                      label: 'Stock Transfer  Report',
                      to: '/pharmacy/inventory/stock-transfer-report'
                    },
                    {
                      id: 'stock-transfer-accept-report',
                      label: 'Stock Transfer Accept Report',
                      to: '/pharmacy/inventory/stock-transfer-accept-report'
                    }
                  ]
                },
                {
                  id: 'stock-reports',
                  label: 'Stock Reports',
                  children: [
                    {
                      id: 'stock-transfer-form',
                      label: 'Stock Transfer Form',
                      to: '/pharmacy/inventory/stock-transfer-form'
                    },
                    {
                      id: 'stock-status',
                      label: 'Stock Status',
                      to: '/pharmacy/inventory/stock-status'
                    },
                    {
                      id: 'stock-transfer-report',
                      label: 'Stock Transfer Report',
                      to: '/pharmacy/inventory/stock-transfer-report'
                    },
                    {
                      id: 'stock-adjutment-report',
                      label: 'Stock Adjument Report',
                      to: '/pharmacy/inventory/stock-adjutment-report'
                    },
                    {
                      id: 'warehouse-report',
                      label: 'Warehouse Report',
                      to: '/pharmacy/inventory/warehouse-report'
                    }
                  ]
                },
                {
                  id: 'batch-wise-reports',
                  label: 'Batch Wise Reports',
                  children: [
                    {
                      id: 'batch-wise-item-transaction',
                      label: 'Batch Wise Item Transaction',
                      to: '/pharmacy/inventory/batch-wise-item-transaction'
                    },
                    {
                      id: 'batch-wise-expired-item',
                      label: 'Batch Wise Expired Item',
                      to: '/pharmacy/inventory/batch-wise-expired-item'
                    }
                  ]
                }
              ]
            },
            {
              id: 'analysis_report',
              label: 'Analysis Report',
              img: REPORT,
              children: [
                {
                  id: 'location-wise-stock-summary',
                  label: 'Location Wise Stock Summary',
                  to: '/pharmacy/inventory/location-wise-stock-summary'
                },
                {
                  id: 'monthly-stock-movement-analysis',
                  label: 'Monthly Stock Movement Analysis',
                  to: '/pharmacy/inventory/monthly-stock-movement-analysis'
                },
                {
                  id: 'update-batch-no',
                  label: 'Update Batch No./Packing Conversion',
                  to: '/pharmacy/inventory/update-batch-no'
                }
              ]
            },
            {
              id: 'Utility',
              label: 'Utility',
              img: UTILITY,
              children: [
                {
                  id: 'update-product-expiry-date',
                  label: 'Update Product Expiry Date',
                  to: '/pharmacy/inventory/update-product-expiry-date'
                },
                {
                  id: 'update-cost-price',
                  label: 'Update Cost Price ',
                  to: '/pharmacy/inventory/update-cost-price'
                },
                {
                  id: 'calculator',
                  label: 'Calculator',
                  to: '/pharmacy/inventory/calculator'
                },
                {
                  id: 'change-company',
                  label: 'Change Company',
                  to: '/pharmacy/inventory/change-company'
                },
                {
                  id: 'change-session',
                  label: 'Change Session',
                  to: '/pharmacy/inventory/change-session'
                },
                {
                  id: 'login-information',
                  label: 'Login Information',
                  to: '/pharmacy/inventory/login-information'
                }
              ]
            }
          ]
        },
        {
          id: 'generalLedger',
          label: 'Ledger',
          img: GENERALLEDGER,
          to: '/general-ledger',
          menu: [
            {
              id: 'master',
              label: 'Master',
              img: DB,
              children: [
                {
                  id: 'account-group-type',
                  label: 'Account Group Type',
                  to: '/pharmacy/general-ledger/account-group-type'
                },
                {
                  id: 'account-group',
                  label: 'Account Group',
                  to: '/pharmacy/general-ledger/account-group'
                },
                {
                  id: 'account-legder',
                  label: 'Account Ledger',
                  to: '/pharmacy/general-ledger/account-ledger'
                },
                {
                  id: 'import-account-ledger',
                  label: 'Import Account Ledger',
                  to: '/pharmacy/general-ledger/import-account-ledger'
                },
                {
                  id: 'request-for-new-supplier-customer',
                  label: 'Request For New Supplier Customer',
                  to: '/pharmacy/general-ledger/request-for-new-supplier-customer'
                },
                {
                  id: 'tax-charge-discount',
                  label: 'Tax Charge Discount',
                  to: '/pharmacy/general-ledger/tax-charge-discount'
                },
                {
                  id: 'online-customer-registration',
                  label: 'Online Customer Registration',
                  to: '/pharmacy/general-ledger/online-customer-registration'
                },
                {
                  id: 'cost-center-type-master',
                  label: 'Cost Center Type Master',
                  to: '/pharmacy/general-ledger/cost-center-type-master'
                },
                {
                  id: 'cost-center-master',
                  label: 'Cost Center Master',
                  to: '/pharmacy/general-ledger/cost-center-master'
                },
                {
                  id: 'analysis-master',
                  label: 'Analysis Master',
                  to: '/pharmacy/general-ledger/analysis-master'
                },
                {
                  id: 'sub-analysis-master',
                  label: 'Sub Analysis Master',
                  to: '/pharmacy/general-ledger/sub-analysis-master'
                }
              ]
            },
            {
              id: 'transaction',
              label: 'Transaction',
              img: TRANSACTION,
              children: [
                {
                  id: 'purchase-invoice',
                  label: 'Purchase Invoice',
                  to: '/pharmacy/general-ledger/purchase-invoice'
                },
                {
                  id: 'supplier-service-invoice',
                  label: 'Supplier Service Invoice',
                  to: '/pharmacy/general-ledger/supplier-service-invoice'
                },
                {
                  id: 'debit-credit-note',
                  label: 'Debit Credit Note',
                  to: '/pharmacy/general-ledger/debit-cedit-note'
                },
                {
                  id: 'patient-receipt-voucher',
                  label: 'Patient Receipt Voucher ',
                  to: '/pharmacy/general-ledger/patient-receipt-voucher'
                },
                {
                  id: 'retail-cash-voucher',
                  label: 'Retail Cash Voucher',
                  to: '/pharmacy/general-ledger/retail-cash-voucher'
                },
                {
                  id: 'bill-opening',
                  label: 'Bill Opening',
                  to: '/pharmacy/general-ledger/bill-opening'
                },
                {
                  id: 'supplier-payment-voucher',
                  label: 'Supplier Payment Voucher',
                  to: '/pharmacy/general-ledger/supplier-payment-voucher'
                },
                {
                  id: 'customer-receipt-voucher',
                  label: 'Customer Receipt  Voucher',
                  to: '/pharmacy/general-ledger/customer-receipt-voucher'
                },
                {
                  id: 'receipt-voucher',
                  label: ' Receipt  Voucher',
                  to: '/pharmacy/general-ledger/receipt-voucher'
                },
                {
                  id: 'payment-voucher',
                  label: 'Payment  Voucher',
                  to: '/pharmacy/general-ledger/payment-voucher'
                },
                {
                  id: 'journal-voucher',
                  label: 'Journal  Voucher',
                  to: '/pharmacy/general-ledger/journal-voucher'
                },
                {
                  id: 'contra-voucher',
                  label: 'Contra Voucher',
                  to: '/pharmacy/general-ledger/contra-voucher'
                },
                {
                  id: 'bank-reconciliation',
                  label: 'Bank Reconciliation',
                  to: '/pharmacy/general-ledger/bank-reconciliation'
                },
                {
                  id: 'adjustment-voucher',
                  label: ' Adjustment  Voucher',
                  to: '/pharmacy/general-ledger/adjustment-voucher'
                },
                {
                  id: 'bulk-authorization',
                  label: 'Bulk Authorization',
                  to: '/pharmacy/general-ledger/bulk-authorization'
                }
              ]
            },
            {
              id: 'report',
              label: 'Report',
              img: REPORT,
              children: [
                {
                  id: 'day-book',
                  label: 'Day Book ',
                  to: '/pharmacy/general-ledger/day-book'
                },
                {
                  id: 'cash-book',
                  label: 'Cash Book',
                  to: '/pharmacy/general-ledger/cash-book'
                },
                {
                  id: 'bank-book',
                  label: 'Bank Book',
                  to: '/pharmacy/general-ledger/bank-book'
                },
                {
                  id: 'ledger',
                  label: 'Ledger',
                  to: '/pharmacy/general-ledger/ledger'
                },
                {
                  id: 'trail-balance',
                  label: 'Trail Balance',
                  to: '/pharmacy/general-ledger/trail-balance'
                },
                {
                  id: 'profit-loss',
                  label: 'Profit & Loss',
                  to: '/pharmacy/general-legder/profit-loss'
                },
                {
                  id: 'balance-sheet',
                  label: 'Balance Sheet',
                  to: '/pharmacy/general-legder/balance-sheet'
                },
                {
                  id: 'customer-outstanding',
                  label: 'Customer Outstanding',
                  to: '/pharmacy/general-ledger/customer-outstanding'
                },
                {
                  id: 'gst-report',
                  label: 'Gst Report',
                  to: '/pharmacy/general-ledger/gst-report'
                },
                {
                  id: 'receipt-voucher-report',
                  label: 'Receipt Voucher Report',
                  to: '/pharmacy/general-ledger/receipt-voucher-report'
                },
                {
                  id: 'payment-voucher-report',
                  label: 'Payment Vocuher Report',
                  to: '/pharmacy/general-ledger/payment-voucher-report'
                },
                {
                  id: 'journal-voucher-report',
                  label: 'Journal Vocuher Report',
                  to: '/pharmacy/general-ledger/journal-voucher-report'
                },
                {
                  id: 'bank-reconcilation-report',
                  label: 'Bank Reconcilation Report',
                  to: '/pharmacy/general-ledger/bank-reconcilation-report'
                }
              ]
            },
            {
              id: 'Utility',
              label: 'Utility',
              img: UTILITY,
              children: [
                {
                  id: 'cost-account-mapping',
                  label: 'Cost Account Mapping',
                  to: '/pharmacy/general-ledger/cost-account-mapping'
                },
                {
                  id: 'sub-analysis-mapping',
                  label: 'Sub Analysis Mapping',
                  to: '/pharmacy/general-ledger/sub-analysis-mapping'
                },
                {
                  id: 'finance-group',
                  label: 'Finance Group',
                  to: '/pharmacy/general-ledger/finance-group'
                }
              ]
            }
          ]
        },
        {
          id: 'admin',
          label: 'admin',
          img: ADMIN,
          to: '/admin',
          menu: [
            {
              id: 'master',
              label: 'Master',
              img: DB
            }
          ]
        }
      ]
    },
    {
      id: 'lab',
      label: 'Lab',
      img: LAB,
      to: '/lab',
      options: [
        {
          id: 'lis',
          label: 'lIS',
          img: LAB,
          to: '/lis',
          menu: [
            {
              id: 'master',
              label: 'Master',
              img: DB,
              children: [
                {
                  id: 'lab-test-main-group-master',
                  label: ' Group Master',
                  to: '/lab/lis/test-main-group-master'
                },
                {
                  id: 'lab-sub-group-master',
                  label: ' Sub Group Master',
                  to: '/lab/lis/test-sub-group-master'
                },
                {
                  id: 'lab-category-master',
                  label: 'Category Master',
                  to: '/lab/lis/category-master'
                },
                {
                  id: 'lab-specimen-master',
                  label: 'Specimen Master',
                  to: '/lab/lis/specimen-master'
                },
                {
                  id: 'lab-test-item-master',
                  label: ' Item Master',
                  to: '/lab/lis/test-item-master'
                },
                {
                  id: 'lab-test-master',
                  label: 'Test Master',
                  to: '/lab/lis/test-master'
                },
                {
                  id: 'lab-lis-discount-master',
                  label: 'Discount Master',
                  to: '/lab/lis/lis-discount-master'
                },
                {
                  id: 'lab-discount-authority-master',
                  label: 'Discount Authority Master',
                  to: '/lab/lis/lis-discount-authority-master'
                },
                {
                  id: 'lab-sponsor-master',
                  label: 'Sponsor Master',
                  to: '/lab/lis/lis-sponsor-master'
                },
                {
                  id: 'lab-templates-master',
                  label: 'Templates Master',
                  to: '/lab/lis/lis-templates-master'
                },
                {
                  id: 'lab-referral-master',
                  label: 'Referral Master',
                  to: '/lab/lis/lis-referral-master'
                },
                {
                  id: 'lab-lab-authority-doctor-master',
                  label: 'Lab Authority Doctor Master',
                  to: '/lab/lis/lab-authority-doctor-master'
                }
              ]
            },
            {
              id: 'transaction',
              label: 'Transaction',
              img: DB,
              children: [
                {
                  id: 'lab-investigation-booking',
                  label: 'Investigation Booking',
                  to: '/lab/lis/investigation-booking'
                },
                {
                  id: 'lab-sample-collection',
                  label: 'Sample Collection',
                  to: '/lab/lis/sample-collection'
                },
                {
                  id: 'lab-result-entry',
                  label: 'Result Entry',
                  to: '/lab/lis/result-entry'
                }
              ]
            },
            {
              id: 'report',
              label: 'Report',
              img: DB,
              children: [
                {
                  id: 'lab-daily-investigation-register',
                  label: 'Daily Investigation Report ',
                  to: '/lab/lis/daily-investigation-report'
                }
              ]
            }
          ]
        },
        {
          id: 'admin',
          label: 'Admin',
          img: ADMIN,
          to: '/admin',
          menu: [
            {
              id: 'setup',
              label: 'Set Up',
              img: DB
            }
          ]
        }
      ]
    }
  ]
});

export default organizationSlice.reducer;
